var items = {
  "block.minecraft.acacia_button": "Gumb od akacije",
  "block.minecraft.acacia_door": "Vrata od akacije",
  "block.minecraft.acacia_fence": "Ograda od akacije",
  "block.minecraft.acacia_fence_gate": "Vrata za ogradu od akacije",
  "block.minecraft.acacia_hanging_sign": "Viseći znak od akacije",
  "block.minecraft.acacia_leaves": "Lišće akacije",
  "block.minecraft.acacia_log": "Trupac akacije",
  "block.minecraft.acacia_planks": "Daske od akacije",
  "block.minecraft.acacia_pressure_plate": "Nagazna ploča od akacije",
  "block.minecraft.acacia_sapling": "Mlado drvo akacije",
  "block.minecraft.acacia_shelf": "Polica od akacije",
  "block.minecraft.acacia_sign": "Znak od akacije",
  "block.minecraft.acacia_slab": "Ploča od akacije",
  "block.minecraft.acacia_stairs": "Stube od akacije",
  "block.minecraft.acacia_trapdoor": "Podna vrata od akacije",
  "block.minecraft.acacia_wall_hanging_sign": "Viseći zidni znak od akacije",
  "block.minecraft.acacia_wall_sign": "Zidni znak od akacije",
  "block.minecraft.acacia_wood": "Drvo akacije",
  "block.minecraft.activator_rail": "Tračnice s aktivatorom",
  "block.minecraft.air": "Zrak",
  "block.minecraft.allium": "Ukrasni luk",
  "block.minecraft.amethyst_block": "Blok ametista",
  "block.minecraft.amethyst_cluster": "Nakupina ametista",
  "block.minecraft.ancient_debris": "Drevni ostaci",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Ploča od andezita",
  "block.minecraft.andesite_stairs": "Stube od andezita",
  "block.minecraft.andesite_wall": "Zid od andezita",
  "block.minecraft.anvil": "Nakovanj",
  "block.minecraft.attached_melon_stem": "Spojena stabljika lubenice",
  "block.minecraft.attached_pumpkin_stem": "Spojena stabljika bundeve",
  "block.minecraft.azalea": "Azaleja",
  "block.minecraft.azalea_leaves": "Lišće azaleje",
  "block.minecraft.azure_bluet": "Plava maćuhica",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok bambusa",
  "block.minecraft.bamboo_button": "Gumb od bambusa",
  "block.minecraft.bamboo_door": "Vrata od bambusa",
  "block.minecraft.bamboo_fence": "Ograda od bambusa",
  "block.minecraft.bamboo_fence_gate": "Vrata za ogradu od bambusa",
  "block.minecraft.bamboo_hanging_sign": "Viseći znak od bambusa",
  "block.minecraft.bamboo_mosaic": "Mozaik bambusa",
  "block.minecraft.bamboo_mosaic_slab": "Ploča od mozaika bambusa",
  "block.minecraft.bamboo_mosaic_stairs": "Stube od mozaika bambusa",
  "block.minecraft.bamboo_planks": "Daske od bambusa",
  "block.minecraft.bamboo_pressure_plate": "Nagazna ploča od bambusa",
  "block.minecraft.bamboo_sapling": "Mlado bambusa",
  "block.minecraft.bamboo_shelf": "Polica od bambusa",
  "block.minecraft.bamboo_sign": "Znak od bambusa",
  "block.minecraft.bamboo_slab": "Ploča od bambusa",
  "block.minecraft.bamboo_stairs": "Stube od bambusa",
  "block.minecraft.bamboo_trapdoor": "Podna vrata od bambusa",
  "block.minecraft.bamboo_wall_hanging_sign": "Viseći zidni znak od bambusa",
  "block.minecraft.bamboo_wall_sign": "Zidni znak od bambusa",
  "block.minecraft.banner.base.black": "Potpuno crno polje",
  "block.minecraft.banner.base.blue": "Potpuno plavo polje",
  "block.minecraft.banner.base.brown": "Potpuno smeđe polje",
  "block.minecraft.banner.base.cyan": "Potpuno tirkizno polje",
  "block.minecraft.banner.base.gray": "Potpuno sivo polje",
  "block.minecraft.banner.base.green": "Potpuno zeleno polje",
  "block.minecraft.banner.base.light_blue": "Potpuno svjetloplavo polje",
  "block.minecraft.banner.base.light_gray": "Potpuno svjetlosivo polje",
  "block.minecraft.banner.base.lime": "Potpuno svjetlozeleno polje",
  "block.minecraft.banner.base.magenta": "Potpuno roza polje",
  "block.minecraft.banner.base.orange": "Potpuno narančasto polje",
  "block.minecraft.banner.base.pink": "Potpuno ružičasto polje",
  "block.minecraft.banner.base.purple": "Potpuno ljubičasto polje",
  "block.minecraft.banner.base.red": "Potpuno crveno polje",
  "block.minecraft.banner.base.white": "Potpuno bijelo polje",
  "block.minecraft.banner.base.yellow": "Potpuno žuto polje",
  "block.minecraft.banner.border.black": "Crni okvir",
  "block.minecraft.banner.border.blue": "Plavi okvir",
  "block.minecraft.banner.border.brown": "Smeđi okvir",
  "block.minecraft.banner.border.cyan": "Tirkizni okvir",
  "block.minecraft.banner.border.gray": "Sivi okvir",
  "block.minecraft.banner.border.green": "Zeleni okvir",
  "block.minecraft.banner.border.light_blue": "Svjetloplavi okvir",
  "block.minecraft.banner.border.light_gray": "Svjetlosivi okvir",
  "block.minecraft.banner.border.lime": "Svjetlozeleni okvir",
  "block.minecraft.banner.border.magenta": "Roza okvir",
  "block.minecraft.banner.border.orange": "Narančasti okvir",
  "block.minecraft.banner.border.pink": "Ružičasti okvir",
  "block.minecraft.banner.border.purple": "Ljubičasti okvir",
  "block.minecraft.banner.border.red": "Crveni okvir",
  "block.minecraft.banner.border.white": "Bijeli okvir",
  "block.minecraft.banner.border.yellow": "Žuti okvir",
  "block.minecraft.banner.bricks.black": "Crno zidano polje",
  "block.minecraft.banner.bricks.blue": "Plavo zidano polje",
  "block.minecraft.banner.bricks.brown": "Smeđe zidano polje",
  "block.minecraft.banner.bricks.cyan": "Tirkizno zidano polje",
  "block.minecraft.banner.bricks.gray": "Sivo zidano polje",
  "block.minecraft.banner.bricks.green": "Zeleno zidano polje",
  "block.minecraft.banner.bricks.light_blue": "Svjetloplavo zidano polje",
  "block.minecraft.banner.bricks.light_gray": "Svjetlosivo zidano polje",
  "block.minecraft.banner.bricks.lime": "Svjetlozeleno zidano polje",
  "block.minecraft.banner.bricks.magenta": "Roza zidano polje",
  "block.minecraft.banner.bricks.orange": "Narančasto zidano polje",
  "block.minecraft.banner.bricks.pink": "Ružičasto zidano polje",
  "block.minecraft.banner.bricks.purple": "Ljubičasto zidano polje",
  "block.minecraft.banner.bricks.red": "Crveno zidano polje",
  "block.minecraft.banner.bricks.white": "BIjelo zidano polje",
  "block.minecraft.banner.bricks.yellow": "Žuto zidano polje",
  "block.minecraft.banner.circle.black": "Crna rondela",
  "block.minecraft.banner.circle.blue": "Plava rondela",
  "block.minecraft.banner.circle.brown": "Smeđa rondela",
  "block.minecraft.banner.circle.cyan": "Tirkizna rondela",
  "block.minecraft.banner.circle.gray": "Siva rondela",
  "block.minecraft.banner.circle.green": "Zelena rondela",
  "block.minecraft.banner.circle.light_blue": "Svjetloplava rondela",
  "block.minecraft.banner.circle.light_gray": "Svjetlosiva rondela",
  "block.minecraft.banner.circle.lime": "Svjetlozelena rondela",
  "block.minecraft.banner.circle.magenta": "Roza rondela",
  "block.minecraft.banner.circle.orange": "Narančasta rondela",
  "block.minecraft.banner.circle.pink": "Ružičasta rondela",
  "block.minecraft.banner.circle.purple": "Ljubičasta rondela",
  "block.minecraft.banner.circle.red": "Crvena rondela",
  "block.minecraft.banner.circle.white": "Bijela rondela",
  "block.minecraft.banner.circle.yellow": "Žuta rondela",
  "block.minecraft.banner.creeper.black": "Crni lik creepera",
  "block.minecraft.banner.creeper.blue": "Plavi lik creepera",
  "block.minecraft.banner.creeper.brown": "Smeđi lik creepera",
  "block.minecraft.banner.creeper.cyan": "Tirkizni lik creepera",
  "block.minecraft.banner.creeper.gray": "Sivi lik creepera",
  "block.minecraft.banner.creeper.green": "Zeleni lik creepera",
  "block.minecraft.banner.creeper.light_blue": "Svjetloplavi lik creepera",
  "block.minecraft.banner.creeper.light_gray": "Svjetlosivi lik creepera",
  "block.minecraft.banner.creeper.lime": "Svjetlozeleni lik creepera",
  "block.minecraft.banner.creeper.magenta": "Roza lik creepera",
  "block.minecraft.banner.creeper.orange": "Narančasti lik creepera",
  "block.minecraft.banner.creeper.pink": "Ružičasti lik creepera",
  "block.minecraft.banner.creeper.purple": "Ljubičasti lik creepera",
  "block.minecraft.banner.creeper.red": "Crveni lik creepera",
  "block.minecraft.banner.creeper.white": "Bijeli lik creepera",
  "block.minecraft.banner.creeper.yellow": "Žuti lik creepera",
  "block.minecraft.banner.cross.black": "Crni Andrijin križ",
  "block.minecraft.banner.cross.blue": "Plavi Andrijin križ",
  "block.minecraft.banner.cross.brown": "Smeđi Andrijin križ",
  "block.minecraft.banner.cross.cyan": "Tirkizni Andrijin križ",
  "block.minecraft.banner.cross.gray": "Sivi Andrijin križ",
  "block.minecraft.banner.cross.green": "Zeleni Andrijin križ",
  "block.minecraft.banner.cross.light_blue": "Svjetloplavi Andrijin križ",
  "block.minecraft.banner.cross.light_gray": "Svjetlosivi Andrijin križ",
  "block.minecraft.banner.cross.lime": "Svjetlozeleni Andrijin križ",
  "block.minecraft.banner.cross.magenta": "Roza Andrijin križ",
  "block.minecraft.banner.cross.orange": "Narančasti Andrijin križ",
  "block.minecraft.banner.cross.pink": "Ružičasti Andrijin križ",
  "block.minecraft.banner.cross.purple": "Ljubičasti Andrijin križ",
  "block.minecraft.banner.cross.red": "Crveni Andrijin križ",
  "block.minecraft.banner.cross.white": "Bijeli Andrijin križ",
  "block.minecraft.banner.cross.yellow": "Žuti Andrijin križ",
  "block.minecraft.banner.curly_border.black": "Crni zupčasti okvir",
  "block.minecraft.banner.curly_border.blue": "Plavi zupčasti okvir",
  "block.minecraft.banner.curly_border.brown": "Smeđi zupčasti okvir",
  "block.minecraft.banner.curly_border.cyan": "Tirkizni zupčasti okvir",
  "block.minecraft.banner.curly_border.gray": "Sivi zupčasti okvir",
  "block.minecraft.banner.curly_border.green": "Zeleni zupčasti okvir",
  "block.minecraft.banner.curly_border.light_blue": "Svjetloplavi zupčasti okvir",
  "block.minecraft.banner.curly_border.light_gray": "Svjetlosivi zupčasti okvir",
  "block.minecraft.banner.curly_border.lime": "Svjetlozeleni zupčasti okvir",
  "block.minecraft.banner.curly_border.magenta": "Roza zupčasti okvir",
  "block.minecraft.banner.curly_border.orange": "Narančasti zupčasti okvir",
  "block.minecraft.banner.curly_border.pink": "Ružičasti zupčasti okvir",
  "block.minecraft.banner.curly_border.purple": "Ljubičasti zupčasti okvir",
  "block.minecraft.banner.curly_border.red": "Crveni zupčasti okvir",
  "block.minecraft.banner.curly_border.white": "Bijeli zupčasti okvir",
  "block.minecraft.banner.curly_border.yellow": "Žuti zupčasti okvir",
  "block.minecraft.banner.diagonal_left.black": "Crna lijevo presječena",
  "block.minecraft.banner.diagonal_left.blue": "Plava lijevo presječena",
  "block.minecraft.banner.diagonal_left.brown": "Smeđa lijevo presječena",
  "block.minecraft.banner.diagonal_left.cyan": "Tirkizna lijevo presječena",
  "block.minecraft.banner.diagonal_left.gray": "Siva lijevo presječena",
  "block.minecraft.banner.diagonal_left.green": "Zelena lijevo presječena",
  "block.minecraft.banner.diagonal_left.light_blue": "Svjetloplava lijevo presječena",
  "block.minecraft.banner.diagonal_left.light_gray": "Svjetlosiva lijevo presječena",
  "block.minecraft.banner.diagonal_left.lime": "Svjetlozelena lijevo presječena",
  "block.minecraft.banner.diagonal_left.magenta": "Roza lijevo presječena",
  "block.minecraft.banner.diagonal_left.orange": "Narančasta lijevo presječena",
  "block.minecraft.banner.diagonal_left.pink": "Ružičasta lijevo presječena",
  "block.minecraft.banner.diagonal_left.purple": "Ljubičasta lijevo presječena",
  "block.minecraft.banner.diagonal_left.red": "Crvena lijevo presječena",
  "block.minecraft.banner.diagonal_left.white": "Bijela lijevo presječena",
  "block.minecraft.banner.diagonal_left.yellow": "Žuta lijevo presječena",
  "block.minecraft.banner.diagonal_right.black": "Crna presječena",
  "block.minecraft.banner.diagonal_right.blue": "Plava presječena",
  "block.minecraft.banner.diagonal_right.brown": "Smeđa presječena",
  "block.minecraft.banner.diagonal_right.cyan": "Tirkizna presječena",
  "block.minecraft.banner.diagonal_right.gray": "Siva presječena",
  "block.minecraft.banner.diagonal_right.green": "Zelena presječena",
  "block.minecraft.banner.diagonal_right.light_blue": "Svjetloplava presječena",
  "block.minecraft.banner.diagonal_right.light_gray": "Svjetlosiva presječena",
  "block.minecraft.banner.diagonal_right.lime": "Svjetlozelena presječena",
  "block.minecraft.banner.diagonal_right.magenta": "Roza presječena",
  "block.minecraft.banner.diagonal_right.orange": "Narančasta presječena",
  "block.minecraft.banner.diagonal_right.pink": "Ružičasta presječena",
  "block.minecraft.banner.diagonal_right.purple": "Ljubičasta presječena",
  "block.minecraft.banner.diagonal_right.red": "Crvena presječena",
  "block.minecraft.banner.diagonal_right.white": "Bijela presječena",
  "block.minecraft.banner.diagonal_right.yellow": "Žuta presječena",
  "block.minecraft.banner.diagonal_up_left.black": "Crna obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.blue": "Plava obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.brown": "Smeđa obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tirkizna obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.gray": "Siva obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.green": "Zelena obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Svjetloplava obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Svjetlosiva obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.lime": "Svjetlozelena obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.magenta": "Roza obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.orange": "Narančasta obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.pink": "Ružičasta obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.purple": "Ljubičasta obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.red": "Crvena obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.white": "Bijela obrnuto presječena",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žuta obrnuto presječena",
  "block.minecraft.banner.diagonal_up_right.black": "Crna obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.blue": "Plava obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.brown": "Smeđa obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tirkizna obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.gray": "Siva obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.green": "Zelena obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Svjetloplava obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Svjetlosiva obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.lime": "Svjetlozelena obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.magenta": "Roza obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.orange": "Narančasta obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.pink": "Ružičasta obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.purple": "Ljubičasta obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.red": "Crvena obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.white": "Bijela obrnuto lijevo presječena",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žuta obrnuto lijevo presječena",
  "block.minecraft.banner.flow.black": "Crni vrtlog",
  "block.minecraft.banner.flow.blue": "Plavi vrtlog",
  "block.minecraft.banner.flow.brown": "Smeđi vrtlog",
  "block.minecraft.banner.flow.cyan": "Tirkizni vrtlog",
  "block.minecraft.banner.flow.gray": "Sivi vrtlog",
  "block.minecraft.banner.flow.green": "Zeleni vrtlog",
  "block.minecraft.banner.flow.light_blue": "Svjetloplavi vrtlog",
  "block.minecraft.banner.flow.light_gray": "Svjetlosivi vrtlog",
  "block.minecraft.banner.flow.lime": "Svjetlozeleni vrtlog",
  "block.minecraft.banner.flow.magenta": "Roza vrtlog",
  "block.minecraft.banner.flow.orange": "Narančasti vrtlog",
  "block.minecraft.banner.flow.pink": "Ružičasti vrtlog",
  "block.minecraft.banner.flow.purple": "Ljubičasti vrtlog",
  "block.minecraft.banner.flow.red": "Crveni vrtlog",
  "block.minecraft.banner.flow.white": "Bijeli vrtlog",
  "block.minecraft.banner.flow.yellow": "Žuti vrtlog",
  "block.minecraft.banner.flower.black": "Crni lik cvijeta",
  "block.minecraft.banner.flower.blue": "Plavi lik cvijeta",
  "block.minecraft.banner.flower.brown": "Smeđi lik cvijeta",
  "block.minecraft.banner.flower.cyan": "Tirkizni lik cvijeta",
  "block.minecraft.banner.flower.gray": "Sivi lik cvijeta",
  "block.minecraft.banner.flower.green": "Zeleni lik cvijeta",
  "block.minecraft.banner.flower.light_blue": "Svjetloplavi lik cvijeta",
  "block.minecraft.banner.flower.light_gray": "Svjetlosivi lik cvijeta",
  "block.minecraft.banner.flower.lime": "Svjetlozeleni lik cvijeta",
  "block.minecraft.banner.flower.magenta": "Roza lik cvijeta",
  "block.minecraft.banner.flower.orange": "Narančasti lik cvijeta",
  "block.minecraft.banner.flower.pink": "Ružičasti lik cvijeta",
  "block.minecraft.banner.flower.purple": "Ljubičasti lik cvijeta",
  "block.minecraft.banner.flower.red": "Crveni lik cvijeta",
  "block.minecraft.banner.flower.white": "Bijeli lik cvijeta",
  "block.minecraft.banner.flower.yellow": "Žuti lik cvijeta",
  "block.minecraft.banner.globe.black": "Crni globus",
  "block.minecraft.banner.globe.blue": "Plavi globus",
  "block.minecraft.banner.globe.brown": "Smeđi globus",
  "block.minecraft.banner.globe.cyan": "Tirkizni globus",
  "block.minecraft.banner.globe.gray": "Sivi globus",
  "block.minecraft.banner.globe.green": "Zeleni globus",
  "block.minecraft.banner.globe.light_blue": "Svjetloplavi globus",
  "block.minecraft.banner.globe.light_gray": "Svjetlosivi globus",
  "block.minecraft.banner.globe.lime": "Svjetlozeleni globus",
  "block.minecraft.banner.globe.magenta": "Roza globus",
  "block.minecraft.banner.globe.orange": "Narančasti globus",
  "block.minecraft.banner.globe.pink": "Ružičasti globus",
  "block.minecraft.banner.globe.purple": "Ljubičasti globus",
  "block.minecraft.banner.globe.red": "Crveni globus",
  "block.minecraft.banner.globe.white": "Bijeli globus",
  "block.minecraft.banner.globe.yellow": "Žuti globus",
  "block.minecraft.banner.gradient.black": "Crni gradijent",
  "block.minecraft.banner.gradient.blue": "Plavi gradijent",
  "block.minecraft.banner.gradient.brown": "Smeđi gradijent",
  "block.minecraft.banner.gradient.cyan": "Tirkizni gradijent",
  "block.minecraft.banner.gradient.gray": "Sivi gradijent",
  "block.minecraft.banner.gradient.green": "Zeleni gradijent",
  "block.minecraft.banner.gradient.light_blue": "Svjetloplavi gradijent",
  "block.minecraft.banner.gradient.light_gray": "Svjetlosivi gradijent",
  "block.minecraft.banner.gradient.lime": "Svjetlozeleni gradijent",
  "block.minecraft.banner.gradient.magenta": "Roza gradijent",
  "block.minecraft.banner.gradient.orange": "Narančasti gradijent",
  "block.minecraft.banner.gradient.pink": "Ružičasti gradijent",
  "block.minecraft.banner.gradient.purple": "Ljubičasti gradijent",
  "block.minecraft.banner.gradient.red": "Crveni gradijent",
  "block.minecraft.banner.gradient.white": "Bijeli gradijent",
  "block.minecraft.banner.gradient.yellow": "Žuti gradijent",
  "block.minecraft.banner.gradient_up.black": "Crni donji gradijent",
  "block.minecraft.banner.gradient_up.blue": "Plavi donji gradijent",
  "block.minecraft.banner.gradient_up.brown": "Smeđi donji gradijent",
  "block.minecraft.banner.gradient_up.cyan": "Tirkizni donji gradijent",
  "block.minecraft.banner.gradient_up.gray": "Sivi donji gradijent",
  "block.minecraft.banner.gradient_up.green": "Zeleni donji gradijent",
  "block.minecraft.banner.gradient_up.light_blue": "Svjetloplavi donji gradijent",
  "block.minecraft.banner.gradient_up.light_gray": "Svjetlosivi donji gradijent",
  "block.minecraft.banner.gradient_up.lime": "Svjetlozeleni donji gradijent",
  "block.minecraft.banner.gradient_up.magenta": "Roza donji gradijent",
  "block.minecraft.banner.gradient_up.orange": "Narančasti donji gradijent",
  "block.minecraft.banner.gradient_up.pink": "Ružičasti donji gradijent",
  "block.minecraft.banner.gradient_up.purple": "Ljubičasti donji gradijent",
  "block.minecraft.banner.gradient_up.red": "Crveni donji gradijent",
  "block.minecraft.banner.gradient_up.white": "Bijeli donji gradijent",
  "block.minecraft.banner.gradient_up.yellow": "Žuti donji gradijent",
  "block.minecraft.banner.guster.black": "Crni zapuh",
  "block.minecraft.banner.guster.blue": "Plavi zapuh",
  "block.minecraft.banner.guster.brown": "Smeđi zapuh",
  "block.minecraft.banner.guster.cyan": "Tirkizni zapuh",
  "block.minecraft.banner.guster.gray": "Sivi zapuh",
  "block.minecraft.banner.guster.green": "Zeleni zapuh",
  "block.minecraft.banner.guster.light_blue": "Svjetloplavi zapuh",
  "block.minecraft.banner.guster.light_gray": "Svjetlosivi zapuh",
  "block.minecraft.banner.guster.lime": "Svjetlozeleni zapuh",
  "block.minecraft.banner.guster.magenta": "Roza zapuh",
  "block.minecraft.banner.guster.orange": "Narančasti zapuh",
  "block.minecraft.banner.guster.pink": "Ružičasti zapuh",
  "block.minecraft.banner.guster.purple": "Ljubičasti zapuh",
  "block.minecraft.banner.guster.red": "Crveni zapuh",
  "block.minecraft.banner.guster.white": "Bijeli zapuh",
  "block.minecraft.banner.guster.yellow": "Žuti zapuh",
  "block.minecraft.banner.half_horizontal.black": "Crna razdijeljena",
  "block.minecraft.banner.half_horizontal.blue": "Plava razdijeljena",
  "block.minecraft.banner.half_horizontal.brown": "Smeđa razdijeljena",
  "block.minecraft.banner.half_horizontal.cyan": "Tirkizna razdijeljena",
  "block.minecraft.banner.half_horizontal.gray": "Siva razdijeljena",
  "block.minecraft.banner.half_horizontal.green": "Zelena razdijeljena",
  "block.minecraft.banner.half_horizontal.light_blue": "Svjetloplava razdijeljena",
  "block.minecraft.banner.half_horizontal.light_gray": "Svjetlosiva razdijeljena",
  "block.minecraft.banner.half_horizontal.lime": "Svjetlozelena razdijeljena",
  "block.minecraft.banner.half_horizontal.magenta": "Roza razdijeljena",
  "block.minecraft.banner.half_horizontal.orange": "Narančasta razdijeljena",
  "block.minecraft.banner.half_horizontal.pink": "Ružičasta razdijeljena",
  "block.minecraft.banner.half_horizontal.purple": "Ljubičasta razdijeljena",
  "block.minecraft.banner.half_horizontal.red": "Crvena razdijeljena",
  "block.minecraft.banner.half_horizontal.white": "Bijela razdijeljena",
  "block.minecraft.banner.half_horizontal.yellow": "Žuta razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.black": "Crna obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Plava obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Smeđa obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tirkizna obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Siva obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zelena obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Svjetloplava obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Svjetlosiva obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Svjetlozelena obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Roza obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Narančasta obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ružičasta obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Ljubičasta obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.red": "Crvena obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bijela obrnuto razdijeljena",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žuta obrnuto razdijeljena",
  "block.minecraft.banner.half_vertical.black": "Crna raskoljena",
  "block.minecraft.banner.half_vertical.blue": "Plava raskoljena",
  "block.minecraft.banner.half_vertical.brown": "Smeđa raskoljena",
  "block.minecraft.banner.half_vertical.cyan": "Tirkizna raskoljena",
  "block.minecraft.banner.half_vertical.gray": "Siva raskoljena",
  "block.minecraft.banner.half_vertical.green": "Zelena raskoljena",
  "block.minecraft.banner.half_vertical.light_blue": "Svjetloplava raskoljena",
  "block.minecraft.banner.half_vertical.light_gray": "Svjetlosiva raskoljena",
  "block.minecraft.banner.half_vertical.lime": "Svjetlozelena raskoljena",
  "block.minecraft.banner.half_vertical.magenta": "Roza raskoljena",
  "block.minecraft.banner.half_vertical.orange": "Narančasta raskoljena",
  "block.minecraft.banner.half_vertical.pink": "Ružičasta raskoljena",
  "block.minecraft.banner.half_vertical.purple": "Ljubičasta raskoljena",
  "block.minecraft.banner.half_vertical.red": "Crvena raskoljena",
  "block.minecraft.banner.half_vertical.white": "Bijela raskoljena",
  "block.minecraft.banner.half_vertical.yellow": "Žuta raskoljena",
  "block.minecraft.banner.half_vertical_right.black": "Crna obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.blue": "Plava obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.brown": "Smeđa obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.cyan": "Tirkizna obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.gray": "Siva obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.green": "Zelena obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.light_blue": "Svjetloplava obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.light_gray": "Svjetlosiva obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.lime": "Svjetlozelena obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.magenta": "Roza obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.orange": "Narančasta obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.pink": "Ružičasta obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.purple": "Ljubičasta obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.red": "Crvena obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.white": "Bijela obrnuto raskoljena",
  "block.minecraft.banner.half_vertical_right.yellow": "Žuta obrnuto raskoljena",
  "block.minecraft.banner.mojang.black": "Crna stvar",
  "block.minecraft.banner.mojang.blue": "Plava stvar",
  "block.minecraft.banner.mojang.brown": "Smeđa stvar",
  "block.minecraft.banner.mojang.cyan": "Tirkizna stvar",
  "block.minecraft.banner.mojang.gray": "Siva stvar",
  "block.minecraft.banner.mojang.green": "Zelena stvar",
  "block.minecraft.banner.mojang.light_blue": "Svjetloplava stvar",
  "block.minecraft.banner.mojang.light_gray": "Svjetlosiva stvar",
  "block.minecraft.banner.mojang.lime": "Svjetlozelena stvar",
  "block.minecraft.banner.mojang.magenta": "Roza stvar",
  "block.minecraft.banner.mojang.orange": "Narančasta stvar",
  "block.minecraft.banner.mojang.pink": "Ružičasta stvar",
  "block.minecraft.banner.mojang.purple": "Ljubičasta stvar",
  "block.minecraft.banner.mojang.red": "Crvena stvar",
  "block.minecraft.banner.mojang.white": "Bijela stvar",
  "block.minecraft.banner.mojang.yellow": "Žuta stvar",
  "block.minecraft.banner.piglin.black": "Crni lik njuške",
  "block.minecraft.banner.piglin.blue": "Plavi lik njuške",
  "block.minecraft.banner.piglin.brown": "Smeđi lik njuške",
  "block.minecraft.banner.piglin.cyan": "Tirkizni lik njuške",
  "block.minecraft.banner.piglin.gray": "Sivi lik njuške",
  "block.minecraft.banner.piglin.green": "Zeleni lik njuške",
  "block.minecraft.banner.piglin.light_blue": "Svjetloplavi lik njuške",
  "block.minecraft.banner.piglin.light_gray": "Svjetlosivi lik njuške",
  "block.minecraft.banner.piglin.lime": "Svjetlozeleni lik njuške",
  "block.minecraft.banner.piglin.magenta": "Roza lik njuške",
  "block.minecraft.banner.piglin.orange": "Narančasti lik njuške",
  "block.minecraft.banner.piglin.pink": "Ružičasti lik njuške",
  "block.minecraft.banner.piglin.purple": "Ljubičasti lik njuške",
  "block.minecraft.banner.piglin.red": "Crveni lik njuške",
  "block.minecraft.banner.piglin.white": "Bijeli lik njuške",
  "block.minecraft.banner.piglin.yellow": "Žuti lik njuške",
  "block.minecraft.banner.rhombus.black": "Crni romb",
  "block.minecraft.banner.rhombus.blue": "Plavi romb",
  "block.minecraft.banner.rhombus.brown": "Smeđi romb",
  "block.minecraft.banner.rhombus.cyan": "Tirkizni romb",
  "block.minecraft.banner.rhombus.gray": "Sivi romb",
  "block.minecraft.banner.rhombus.green": "Zeleni romb",
  "block.minecraft.banner.rhombus.light_blue": "Svjetloplavi romb",
  "block.minecraft.banner.rhombus.light_gray": "Svjetlosivi romb",
  "block.minecraft.banner.rhombus.lime": "Svjetlozeleni romb",
  "block.minecraft.banner.rhombus.magenta": "Roza romb",
  "block.minecraft.banner.rhombus.orange": "Narančasti romb",
  "block.minecraft.banner.rhombus.pink": "Ružičasti romb",
  "block.minecraft.banner.rhombus.purple": "Ljubičasti romb",
  "block.minecraft.banner.rhombus.red": "Crveni romb",
  "block.minecraft.banner.rhombus.white": "Bijeli romb",
  "block.minecraft.banner.rhombus.yellow": "Žuti romb",
  "block.minecraft.banner.skull.black": "Crni lik lubanje",
  "block.minecraft.banner.skull.blue": "Plavi lik lubanje",
  "block.minecraft.banner.skull.brown": "Smeđi lik lubanje",
  "block.minecraft.banner.skull.cyan": "Tirkizni lik lubanje",
  "block.minecraft.banner.skull.gray": "Sivi lik lubanje",
  "block.minecraft.banner.skull.green": "Zeleni lik lubanje",
  "block.minecraft.banner.skull.light_blue": "Svjetloplavi lik lubanje",
  "block.minecraft.banner.skull.light_gray": "Svjetlosivi lik lubanje",
  "block.minecraft.banner.skull.lime": "Svjetlozeleni lik lubanje",
  "block.minecraft.banner.skull.magenta": "Roza lik lubanje",
  "block.minecraft.banner.skull.orange": "Narančasti lik lubanje",
  "block.minecraft.banner.skull.pink": "Ružičasti lik lubanje",
  "block.minecraft.banner.skull.purple": "Ljubičasti lik lubanje",
  "block.minecraft.banner.skull.red": "Crveni lik lubanje",
  "block.minecraft.banner.skull.white": "Bijeli lik lubanje",
  "block.minecraft.banner.skull.yellow": "Žuti lik lubanje",
  "block.minecraft.banner.small_stripes.black": "Crna stupčasta",
  "block.minecraft.banner.small_stripes.blue": "Plava stupčasta",
  "block.minecraft.banner.small_stripes.brown": "Smeđa stupčasta",
  "block.minecraft.banner.small_stripes.cyan": "Tirkizna stupčasta",
  "block.minecraft.banner.small_stripes.gray": "Siva stupčasta",
  "block.minecraft.banner.small_stripes.green": "Zelena stupčasta",
  "block.minecraft.banner.small_stripes.light_blue": "Svjetloplava stupčasta",
  "block.minecraft.banner.small_stripes.light_gray": "Svjetlosiva stupčasta",
  "block.minecraft.banner.small_stripes.lime": "Svjetlozelena stupčasta",
  "block.minecraft.banner.small_stripes.magenta": "Roza stupčasta",
  "block.minecraft.banner.small_stripes.orange": "Narančasta stupčasta",
  "block.minecraft.banner.small_stripes.pink": "Ružičasta stupčasta",
  "block.minecraft.banner.small_stripes.purple": "Ljubičasta stupčasta",
  "block.minecraft.banner.small_stripes.red": "Crvena stupčasta",
  "block.minecraft.banner.small_stripes.white": "Bijela stupčasta",
  "block.minecraft.banner.small_stripes.yellow": "Žuta stupčasta",
  "block.minecraft.banner.square_bottom_left.black": "Crni donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.blue": "Plavi donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.brown": "Smeđi donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.cyan": "Tirkizni donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.gray": "Sivi donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.green": "Zeleni donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.light_blue": "Svjetloplavi donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.light_gray": "Svjetlosivi donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.lime": "Svjetlozeleni donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.magenta": "Roza donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.orange": "Narančasti donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.pink": "Ružičasti donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.purple": "Ljubičasti donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.red": "Crveni donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.white": "Bijeli donji desni kvadrant",
  "block.minecraft.banner.square_bottom_left.yellow": "Žuti donji desni kvadrant",
  "block.minecraft.banner.square_bottom_right.black": "Crni donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.blue": "Plavi donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.brown": "Smeđi donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.cyan": "Tirkizni donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.gray": "Sivi donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.green": "Zeleni donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.light_blue": "Svjetloplavi donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.light_gray": "Svjetlosivi donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.lime": "Svjetlozeleni donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.magenta": "Roza donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.orange": "Narančasti donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.pink": "Ružičasti donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.purple": "Ljubičasti donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.red": "Crveni donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.white": "Bijeli donji lijevi kvadrant",
  "block.minecraft.banner.square_bottom_right.yellow": "Žuti donji lijevi kvadrant",
  "block.minecraft.banner.square_top_left.black": "Crni gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.blue": "Plavi gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.brown": "Smeđi gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.cyan": "Tirkizni gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.gray": "Sivi gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.green": "Zeleni gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.light_blue": "Svjetloplavi gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.light_gray": "Svjetlosivi gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.lime": "Svjetlozeleni gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.magenta": "Roza gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.orange": "Narančasti gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.pink": "Ružičasti gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.purple": "Ljubičasti gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.red": "Crveni gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.white": "Bijeli gornji desni kvadrant",
  "block.minecraft.banner.square_top_left.yellow": "Žuti gornji desni kvadrant",
  "block.minecraft.banner.square_top_right.black": "Crni gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.blue": "Plavi gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.brown": "Smeđi gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.cyan": "Trikizni gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.gray": "Sivi gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.green": "Zeleni gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.light_blue": "Svjetloplavi gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.light_gray": "Svjetlosivi gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.lime": "Svjetlozeleni gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.magenta": "Roza gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.orange": "Narančasti gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.pink": "Ružičasti gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.purple": "Ljubičasti gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.red": "Crveni gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.white": "Bijeli gornji lijevi kvadrant",
  "block.minecraft.banner.square_top_right.yellow": "Žuti gornji lijevi kvadrant",
  "block.minecraft.banner.straight_cross.black": "Crni križ",
  "block.minecraft.banner.straight_cross.blue": "Plavi križ",
  "block.minecraft.banner.straight_cross.brown": "Smeđi križ",
  "block.minecraft.banner.straight_cross.cyan": "Tirkizni križ",
  "block.minecraft.banner.straight_cross.gray": "Sivi križ",
  "block.minecraft.banner.straight_cross.green": "Zeleni križ",
  "block.minecraft.banner.straight_cross.light_blue": "Svjetloplavi križ",
  "block.minecraft.banner.straight_cross.light_gray": "Svjetlosivi križ",
  "block.minecraft.banner.straight_cross.lime": "Svjetlozeleni križ",
  "block.minecraft.banner.straight_cross.magenta": "Roza križ",
  "block.minecraft.banner.straight_cross.orange": "Narančasti križ",
  "block.minecraft.banner.straight_cross.pink": "Ružičasti križ",
  "block.minecraft.banner.straight_cross.purple": "Ljubičasti križ",
  "block.minecraft.banner.straight_cross.red": "Crveni križ",
  "block.minecraft.banner.straight_cross.white": "Bijeli križ",
  "block.minecraft.banner.straight_cross.yellow": "Žuti križ",
  "block.minecraft.banner.stripe_bottom.black": "Crna donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.blue": "Plava donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.brown": "Smeđa donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.cyan": "Tirkizna donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.gray": "Siva donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.green": "Zelena donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.light_blue": "Svjetloplava donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.light_gray": "Svjetlosiva donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.lime": "Svjetlozelena donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.magenta": "Roza donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.orange": "Narančasta donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.pink": "Ružičasta donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.purple": "Ljubičasta donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.red": "Crvena donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.white": "Bijela donja poprečna greda",
  "block.minecraft.banner.stripe_bottom.yellow": "Žuta donja poprečna greda",
  "block.minecraft.banner.stripe_center.black": "Crni stupac",
  "block.minecraft.banner.stripe_center.blue": "Plavi stupac",
  "block.minecraft.banner.stripe_center.brown": "Smeđi stupac",
  "block.minecraft.banner.stripe_center.cyan": "Tirkizni stupac",
  "block.minecraft.banner.stripe_center.gray": "Sivi stupac",
  "block.minecraft.banner.stripe_center.green": "Zeleni stupac",
  "block.minecraft.banner.stripe_center.light_blue": "Svjetloplavi stupac",
  "block.minecraft.banner.stripe_center.light_gray": "Svjetlosivi stupac",
  "block.minecraft.banner.stripe_center.lime": "Svjetlozeleni stupac",
  "block.minecraft.banner.stripe_center.magenta": "Roza stupac",
  "block.minecraft.banner.stripe_center.orange": "Narančasti stupac",
  "block.minecraft.banner.stripe_center.pink": "Ružičasti stupac",
  "block.minecraft.banner.stripe_center.purple": "Ljubičasti stupac",
  "block.minecraft.banner.stripe_center.red": "Crveni stupac",
  "block.minecraft.banner.stripe_center.white": "Bijeli stupac",
  "block.minecraft.banner.stripe_center.yellow": "Žuti stupac",
  "block.minecraft.banner.stripe_downleft.black": "Crna kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.blue": "Plava kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.brown": "Smeđa kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.cyan": "Tirkizna kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.gray": "Siva kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.green": "Zelena kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.light_blue": "Svjetloplava kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.light_gray": "Svjetlosiva kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.lime": "Svjetlozelena kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.magenta": "Roza kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.orange": "Narančasta kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.pink": "Ružičasta kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.purple": "Ljubičasta kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.red": "Crvena kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.white": "Bijela kosa lijeva greda",
  "block.minecraft.banner.stripe_downleft.yellow": "Žuta kosa lijeva greda",
  "block.minecraft.banner.stripe_downright.black": "Crna kosa greda",
  "block.minecraft.banner.stripe_downright.blue": "Plava kosa greda",
  "block.minecraft.banner.stripe_downright.brown": "Smeđa kosa greda",
  "block.minecraft.banner.stripe_downright.cyan": "Tirkizna kosa greda",
  "block.minecraft.banner.stripe_downright.gray": "Siva kosa greda",
  "block.minecraft.banner.stripe_downright.green": "Zelena kosa greda",
  "block.minecraft.banner.stripe_downright.light_blue": "Svjetloplava kosa greda",
  "block.minecraft.banner.stripe_downright.light_gray": "Svjetlosiva kosa greda",
  "block.minecraft.banner.stripe_downright.lime": "Svjetlozelena kosa greda",
  "block.minecraft.banner.stripe_downright.magenta": "Roza kosa greda",
  "block.minecraft.banner.stripe_downright.orange": "Narančasta kosa greda",
  "block.minecraft.banner.stripe_downright.pink": "Ružičasta kosa greda",
  "block.minecraft.banner.stripe_downright.purple": "Ljubičasta kosa greda",
  "block.minecraft.banner.stripe_downright.red": "Crvena kosa greda",
  "block.minecraft.banner.stripe_downright.white": "Bijela kosa greda",
  "block.minecraft.banner.stripe_downright.yellow": "Žuta kosa greda",
  "block.minecraft.banner.stripe_left.black": "Crni desni stupac",
  "block.minecraft.banner.stripe_left.blue": "Plavi desni stupac",
  "block.minecraft.banner.stripe_left.brown": "Smeđi desni stupac",
  "block.minecraft.banner.stripe_left.cyan": "Tirkizni desni stupac",
  "block.minecraft.banner.stripe_left.gray": "Sivi desni stupac",
  "block.minecraft.banner.stripe_left.green": "Zeleni desni stupac",
  "block.minecraft.banner.stripe_left.light_blue": "Svjetloplavi desni stupac",
  "block.minecraft.banner.stripe_left.light_gray": "Svjetlosivi desni stupac",
  "block.minecraft.banner.stripe_left.lime": "Svjetlozeleni desni stupac",
  "block.minecraft.banner.stripe_left.magenta": "Roza desni stupac",
  "block.minecraft.banner.stripe_left.orange": "Narančasti desni stupac",
  "block.minecraft.banner.stripe_left.pink": "Ružičasti desni stupac",
  "block.minecraft.banner.stripe_left.purple": "Ljubičasti desni stupac",
  "block.minecraft.banner.stripe_left.red": "Crveni desni stupac",
  "block.minecraft.banner.stripe_left.white": "Bijeli desni stupac",
  "block.minecraft.banner.stripe_left.yellow": "Žuti desni stupac",
  "block.minecraft.banner.stripe_middle.black": "Crna poprečna greda",
  "block.minecraft.banner.stripe_middle.blue": "Plava poprečna greda",
  "block.minecraft.banner.stripe_middle.brown": "Smeđa poprečna greda",
  "block.minecraft.banner.stripe_middle.cyan": "Tirkizna poprečna greda",
  "block.minecraft.banner.stripe_middle.gray": "Siva poprečna greda",
  "block.minecraft.banner.stripe_middle.green": "Zelena poprečna greda",
  "block.minecraft.banner.stripe_middle.light_blue": "Svjetloplava poprečna greda",
  "block.minecraft.banner.stripe_middle.light_gray": "Svjetlosiva poprečna greda",
  "block.minecraft.banner.stripe_middle.lime": "Svjetlozelena poprečna greda",
  "block.minecraft.banner.stripe_middle.magenta": "Roza poprečna greda",
  "block.minecraft.banner.stripe_middle.orange": "Narančasta poprečna greda",
  "block.minecraft.banner.stripe_middle.pink": "Ružičasta poprečna greda",
  "block.minecraft.banner.stripe_middle.purple": "Ljubičasta poprečna greda",
  "block.minecraft.banner.stripe_middle.red": "Crvena poprečna greda",
  "block.minecraft.banner.stripe_middle.white": "Bijela poprečna greda",
  "block.minecraft.banner.stripe_middle.yellow": "Žuta poprečna greda",
  "block.minecraft.banner.stripe_right.black": "Crni lijevi stupac",
  "block.minecraft.banner.stripe_right.blue": "Plavi lijevi stupac",
  "block.minecraft.banner.stripe_right.brown": "Smeđi lijevi stupac",
  "block.minecraft.banner.stripe_right.cyan": "Trikizni lijevi stupac",
  "block.minecraft.banner.stripe_right.gray": "Sivi lijevi stupac",
  "block.minecraft.banner.stripe_right.green": "Zeleni lijevi stupac",
  "block.minecraft.banner.stripe_right.light_blue": "Svjetloplavi lijevi stupac",
  "block.minecraft.banner.stripe_right.light_gray": "Svjetlosivi lijevi stupac",
  "block.minecraft.banner.stripe_right.lime": "Svjetlozeleni lijevi stupac",
  "block.minecraft.banner.stripe_right.magenta": "Roza lijevi stupac",
  "block.minecraft.banner.stripe_right.orange": "Narančasti lijevi stupac",
  "block.minecraft.banner.stripe_right.pink": "Ružičasti lijevi stupac",
  "block.minecraft.banner.stripe_right.purple": "Ljubičasti lijevi stupac",
  "block.minecraft.banner.stripe_right.red": "Crveni lijevi stupac",
  "block.minecraft.banner.stripe_right.white": "Bijeli lijevi stupac",
  "block.minecraft.banner.stripe_right.yellow": "Žuti lijevi stupac",
  "block.minecraft.banner.stripe_top.black": "Crna gornja poprečna greda",
  "block.minecraft.banner.stripe_top.blue": "Plava gornja poprečna greda",
  "block.minecraft.banner.stripe_top.brown": "Smeđa gornja poprečna greda",
  "block.minecraft.banner.stripe_top.cyan": "Tirkizna gornja poprečna greda",
  "block.minecraft.banner.stripe_top.gray": "Siva gornja poprečna greda",
  "block.minecraft.banner.stripe_top.green": "Zelena gornja poprečna greda",
  "block.minecraft.banner.stripe_top.light_blue": "Svjetloplava gornja poprečna greda",
  "block.minecraft.banner.stripe_top.light_gray": "Svjetlosiva gornja poprečna greda",
  "block.minecraft.banner.stripe_top.lime": "Svjetlozelena gornja poprečna greda",
  "block.minecraft.banner.stripe_top.magenta": "Roza gornja poprečna greda",
  "block.minecraft.banner.stripe_top.orange": "Narančasta gornja poprečna greda",
  "block.minecraft.banner.stripe_top.pink": "Roza gornja poprečna greda",
  "block.minecraft.banner.stripe_top.purple": "Ljubičasta gornja poprečna greda",
  "block.minecraft.banner.stripe_top.red": "Crvena gornja poprečna greda",
  "block.minecraft.banner.stripe_top.white": "Bijela gornja poprečna greda",
  "block.minecraft.banner.stripe_top.yellow": "Žuta gornja poprečna greda",
  "block.minecraft.banner.triangle_bottom.black": "Crni šiljak",
  "block.minecraft.banner.triangle_bottom.blue": "Plavi šiljak",
  "block.minecraft.banner.triangle_bottom.brown": "Smeđi šiljak",
  "block.minecraft.banner.triangle_bottom.cyan": "Tirkizni šiljak",
  "block.minecraft.banner.triangle_bottom.gray": "Sivi šiljak",
  "block.minecraft.banner.triangle_bottom.green": "Zeleni šiljak",
  "block.minecraft.banner.triangle_bottom.light_blue": "Svjetloplavi šiljak",
  "block.minecraft.banner.triangle_bottom.light_gray": "Svjetlosivi šiljak",
  "block.minecraft.banner.triangle_bottom.lime": "Svjetlozeleni šiljak",
  "block.minecraft.banner.triangle_bottom.magenta": "Roza šiljak",
  "block.minecraft.banner.triangle_bottom.orange": "Narančasti šiljak",
  "block.minecraft.banner.triangle_bottom.pink": "Ružičasti šiljak",
  "block.minecraft.banner.triangle_bottom.purple": "Ljubičasti šiljak",
  "block.minecraft.banner.triangle_bottom.red": "Crveni šiljak",
  "block.minecraft.banner.triangle_bottom.white": "Bijeli šiljak",
  "block.minecraft.banner.triangle_bottom.yellow": "Žuti šiljak",
  "block.minecraft.banner.triangle_top.black": "Crni obrnuti šiljak",
  "block.minecraft.banner.triangle_top.blue": "Plavi obrnuti šiljak",
  "block.minecraft.banner.triangle_top.brown": "Smeđi obrnuti šiljak",
  "block.minecraft.banner.triangle_top.cyan": "Tirkizni obrnuti šiljak",
  "block.minecraft.banner.triangle_top.gray": "Sivi obrnuti šiljak",
  "block.minecraft.banner.triangle_top.green": "Zeleni obrnuti šiljak",
  "block.minecraft.banner.triangle_top.light_blue": "Svjetloplavi obrnuti šiljak",
  "block.minecraft.banner.triangle_top.light_gray": "Svjetlosivi obrnuti šiljak",
  "block.minecraft.banner.triangle_top.lime": "Svjetlozeleni obrnuti šiljak",
  "block.minecraft.banner.triangle_top.magenta": "Roza obrnuti šiljak",
  "block.minecraft.banner.triangle_top.orange": "Narančasti obrnuti šiljak",
  "block.minecraft.banner.triangle_top.pink": "Ružičasti obrnuti šiljak",
  "block.minecraft.banner.triangle_top.purple": "Ljubičasti obrnuti šiljak",
  "block.minecraft.banner.triangle_top.red": "Crveni obrnuti šiljak",
  "block.minecraft.banner.triangle_top.white": "Bijeli obrnuti šiljak",
  "block.minecraft.banner.triangle_top.yellow": "Žuti obrnuti šiljak",
  "block.minecraft.banner.triangles_bottom.black": "Crna donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.blue": "Plava donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.brown": "Smeđa donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.cyan": "Tirkizna donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.gray": "Siva donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.green": "Zelena donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.light_blue": "Svjetloplava donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.light_gray": "Svjetlosiva donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.lime": "Svjetlozelena donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.magenta": "Roza donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.orange": "Narančasta donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.pink": "Ružičasta donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.purple": "Ljubičasta donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.red": "Crvena donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.white": "Bijela donja zupčasta greda",
  "block.minecraft.banner.triangles_bottom.yellow": "Žuta donja zupčasta greda",
  "block.minecraft.banner.triangles_top.black": "Crna gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.blue": "Plava gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.brown": "Smeđa gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.cyan": "Tirkizna gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.gray": "Siva gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.green": "Zelena gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.light_blue": "Svjetloplava gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.light_gray": "Svjetlosiva gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.lime": "Svjetlozelena gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.magenta": "Roza gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.orange": "Narančasta gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.pink": "Ružičasta gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.purple": "Ljubičasta gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.red": "Crvena gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.white": "Bijela gornja zupčasta greda",
  "block.minecraft.banner.triangles_top.yellow": "Žuta gornja zupčasta greda",
  "block.minecraft.barrel": "Bačva",
  "block.minecraft.barrier": "Barijera",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Svjetionik",
  "block.minecraft.beacon.primary": "Glavna moć",
  "block.minecraft.beacon.secondary": "Sekundarna moć",
  "block.minecraft.bed.no_sleep": "Možeš spavati jedino noću ili tijekom oluje",
  "block.minecraft.bed.not_safe": "Sada se ne možeš odmarati; čudovišta su u blizini",
  "block.minecraft.bed.obstructed": "Ovaj krevet je zapriječen",
  "block.minecraft.bed.occupied": "Krevet je zauzet",
  "block.minecraft.bed.too_far_away": "Sada se ne možeš odmarati; krevet je predaleko",
  "block.minecraft.bedrock": "Temelj",
  "block.minecraft.bee_nest": "Pčelinje gnijezdo",
  "block.minecraft.beehive": "Košnica",
  "block.minecraft.beetroots": "Cikle",
  "block.minecraft.bell": "Zvono",
  "block.minecraft.big_dripleaf": "Veliki kaplist",
  "block.minecraft.big_dripleaf_stem": "Stabljika velikog kaplista",
  "block.minecraft.birch_button": "Gumb od breze",
  "block.minecraft.birch_door": "Vrata od breze",
  "block.minecraft.birch_fence": "Ograda od breze",
  "block.minecraft.birch_fence_gate": "Vrata za ogradu od breze",
  "block.minecraft.birch_hanging_sign": "Viseći znak od breze",
  "block.minecraft.birch_leaves": "Lišće breze",
  "block.minecraft.birch_log": "Trupac breze",
  "block.minecraft.birch_planks": "Daske od breze",
  "block.minecraft.birch_pressure_plate": "Nagazna ploča od breze",
  "block.minecraft.birch_sapling": "Mlado drvo breze",
  "block.minecraft.birch_shelf": "Polica od breze",
  "block.minecraft.birch_sign": "Znak od breze",
  "block.minecraft.birch_slab": "Ploča od breze",
  "block.minecraft.birch_stairs": "Stube od breze",
  "block.minecraft.birch_trapdoor": "Podna vrata od breze",
  "block.minecraft.birch_wall_hanging_sign": "Viseći zidni znak od breze",
  "block.minecraft.birch_wall_sign": "Zidni znak od breze",
  "block.minecraft.birch_wood": "Brezovina",
  "block.minecraft.black_banner": "Crna zastava",
  "block.minecraft.black_bed": "Crni krevet",
  "block.minecraft.black_candle": "Crna svijeća",
  "block.minecraft.black_candle_cake": "Torta s crnom svijećom",
  "block.minecraft.black_carpet": "Crni tepih",
  "block.minecraft.black_concrete": "Crni beton",
  "block.minecraft.black_concrete_powder": "Crni prah betona",
  "block.minecraft.black_glazed_terracotta": "Crna glazirana terakota",
  "block.minecraft.black_shulker_box": "Crna shulker kutija",
  "block.minecraft.black_stained_glass": "Crno staklo",
  "block.minecraft.black_stained_glass_pane": "Crna staklena ploča",
  "block.minecraft.black_terracotta": "Crna terakota",
  "block.minecraft.black_wool": "Crna vuna",
  "block.minecraft.blackstone": "Crni kamen",
  "block.minecraft.blackstone_slab": "Ploča od crnog kamena",
  "block.minecraft.blackstone_stairs": "Stube od crnog kamena",
  "block.minecraft.blackstone_wall": "Zid od crnog kamena",
  "block.minecraft.blast_furnace": "Visoka peć",
  "block.minecraft.blue_banner": "Plava zastava",
  "block.minecraft.blue_bed": "Plavi krevet",
  "block.minecraft.blue_candle": "Plava svijeća",
  "block.minecraft.blue_candle_cake": "Torta s plavom svijećom",
  "block.minecraft.blue_carpet": "Plavi tepih",
  "block.minecraft.blue_concrete": "Plavi beton",
  "block.minecraft.blue_concrete_powder": "Plavi prah betona",
  "block.minecraft.blue_glazed_terracotta": "Plava glazirana terakota",
  "block.minecraft.blue_ice": "Plavi led",
  "block.minecraft.blue_orchid": "Plava orhideja",
  "block.minecraft.blue_shulker_box": "Plava shulker kutija",
  "block.minecraft.blue_stained_glass": "Plavo staklo",
  "block.minecraft.blue_stained_glass_pane": "Plava staklena ploča",
  "block.minecraft.blue_terracotta": "Plava terakota",
  "block.minecraft.blue_wool": "Plava vuna",
  "block.minecraft.bone_block": "Koštani blok",
  "block.minecraft.bookshelf": "Polica s knjigama",
  "block.minecraft.brain_coral": "Mozgov koralj",
  "block.minecraft.brain_coral_block": "Blok mozgovog koralja",
  "block.minecraft.brain_coral_fan": "Mozgov kožasti koralj",
  "block.minecraft.brain_coral_wall_fan": "Bočni mozgov kožasti koralj",
  "block.minecraft.brewing_stand": "Postolje za napitke",
  "block.minecraft.brick_slab": "Ploča od cigala",
  "block.minecraft.brick_stairs": "Stube od cigala",
  "block.minecraft.brick_wall": "Zid od cigala",
  "block.minecraft.bricks": "Cigle",
  "block.minecraft.brown_banner": "Smeđa zastava",
  "block.minecraft.brown_bed": "Smeđi krevet",
  "block.minecraft.brown_candle": "Smeđa svijeća",
  "block.minecraft.brown_candle_cake": "Torta sa smeđom svijećom",
  "block.minecraft.brown_carpet": "Smeđi tepih",
  "block.minecraft.brown_concrete": "Smeđi beton",
  "block.minecraft.brown_concrete_powder": "Smeđi prah betona",
  "block.minecraft.brown_glazed_terracotta": "Smeđa glazirana terakota",
  "block.minecraft.brown_mushroom": "Smeđa gljiva",
  "block.minecraft.brown_mushroom_block": "Blok smeđe gljive",
  "block.minecraft.brown_shulker_box": "Smeđa shulker kutija",
  "block.minecraft.brown_stained_glass": "Smeđe staklo",
  "block.minecraft.brown_stained_glass_pane": "Smeđa staklena ploča",
  "block.minecraft.brown_terracotta": "Smeđa terakota",
  "block.minecraft.brown_wool": "Smeđa vuna",
  "block.minecraft.bubble_column": "Stupac mjehurića",
  "block.minecraft.bubble_coral": "Mjehuričasti koralj",
  "block.minecraft.bubble_coral_block": "Blok mjehuričastog koralja",
  "block.minecraft.bubble_coral_fan": "Mjehuričasti kožasti koralj",
  "block.minecraft.bubble_coral_wall_fan": "Bočni mjehuričasti kožasti koralj",
  "block.minecraft.budding_amethyst": "Stvarač ametista",
  "block.minecraft.bush": "Grm",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusov cvijet",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrirani sculk senzor",
  "block.minecraft.campfire": "Logorska vatra",
  "block.minecraft.candle": "Svijeća",
  "block.minecraft.candle_cake": "Torta sa svijećom",
  "block.minecraft.carrots": "Mrkve",
  "block.minecraft.cartography_table": "Stol za kartografiju",
  "block.minecraft.carved_pumpkin": "Urezana bundeva",
  "block.minecraft.cauldron": "Kotao",
  "block.minecraft.cave_air": "Zrak špilje",
  "block.minecraft.cave_vines": "Špiljska loza",
  "block.minecraft.cave_vines_plant": "Biljka špiljske loze",
  "block.minecraft.chain": "Lanac",
  "block.minecraft.chain_command_block": "Lančani naredbeni blok",
  "block.minecraft.cherry_button": "Gumb od trešnje",
  "block.minecraft.cherry_door": "Vrata od trešnje",
  "block.minecraft.cherry_fence": "Ograda od trešnje",
  "block.minecraft.cherry_fence_gate": "Vrata za ogradu od trešnje",
  "block.minecraft.cherry_hanging_sign": "Viseći znak od trešnje",
  "block.minecraft.cherry_leaves": "Lišće trešnje",
  "block.minecraft.cherry_log": "Trupac trešnje",
  "block.minecraft.cherry_planks": "Daske od trešnje",
  "block.minecraft.cherry_pressure_plate": "Nagazna ploča od trešnje",
  "block.minecraft.cherry_sapling": "Mlado drvo trešnje",
  "block.minecraft.cherry_shelf": "Polica od trešnje",
  "block.minecraft.cherry_sign": "Znak od trešnje",
  "block.minecraft.cherry_slab": "Ploča od trešnje",
  "block.minecraft.cherry_stairs": "Stube od trešnje",
  "block.minecraft.cherry_trapdoor": "Podna vrata od trešnje",
  "block.minecraft.cherry_wall_hanging_sign": "Viseći zidni znak od trešnje",
  "block.minecraft.cherry_wall_sign": "Zidni znak od trešnje",
  "block.minecraft.cherry_wood": "Trešnjevina",
  "block.minecraft.chest": "Škrinja",
  "block.minecraft.chipped_anvil": "Okrnjen nakovanj",
  "block.minecraft.chiseled_bookshelf": "Isklesana polica s knjigama",
  "block.minecraft.chiseled_copper": "Isklesani bakar",
  "block.minecraft.chiseled_deepslate": "Isklesani škriljevac",
  "block.minecraft.chiseled_nether_bricks": "Isklesane nether cigle",
  "block.minecraft.chiseled_polished_blackstone": "Isklesani polirani crni kamen",
  "block.minecraft.chiseled_quartz_block": "Isklesani blok kvarca",
  "block.minecraft.chiseled_red_sandstone": "Isklesani crveni pješčenjak",
  "block.minecraft.chiseled_resin_bricks": "Isklesane smoline cigle",
  "block.minecraft.chiseled_sandstone": "Isklesani pješčenjak",
  "block.minecraft.chiseled_stone_bricks": "Isklesane kamene cigle",
  "block.minecraft.chiseled_tuff": "Isklesani tuf",
  "block.minecraft.chiseled_tuff_bricks": "Isklesane cigle od tufa",
  "block.minecraft.chorus_flower": "Chorusov cvijet",
  "block.minecraft.chorus_plant": "Chorus biljka",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zatvorena tratinčica",
  "block.minecraft.coal_block": "Blok ugljena",
  "block.minecraft.coal_ore": "Ugljena ruda",
  "block.minecraft.coarse_dirt": "Gruba zemlja",
  "block.minecraft.cobbled_deepslate": "Kameni škriljevac",
  "block.minecraft.cobbled_deepslate_slab": "Ploča od kamenog škriljevca",
  "block.minecraft.cobbled_deepslate_stairs": "Stube od kamenog škriljevca",
  "block.minecraft.cobbled_deepslate_wall": "Zid od kamenog škriljevca",
  "block.minecraft.cobblestone": "Kaldrma",
  "block.minecraft.cobblestone_slab": "Ploča od kaldrme",
  "block.minecraft.cobblestone_stairs": "Stube od kaldrme",
  "block.minecraft.cobblestone_wall": "Zid od kaldrme",
  "block.minecraft.cobweb": "Paučina",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Naredbeni blok",
  "block.minecraft.comparator": "Redstone komparator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Konduktor",
  "block.minecraft.copper_bars": "Bakrene šipke",
  "block.minecraft.copper_block": "Blok bakra",
  "block.minecraft.copper_bulb": "Bakrena žarulja",
  "block.minecraft.copper_chain": "Lanac od bakra",
  "block.minecraft.copper_chest": "Škrinja od bakra",
  "block.minecraft.copper_door": "Bakrena vrata",
  "block.minecraft.copper_golem_statue": "Kip bakrenog golema",
  "block.minecraft.copper_grate": "Bakrena rešetka",
  "block.minecraft.copper_lantern": "Svjetiljka od bakra",
  "block.minecraft.copper_ore": "Bakrena ruda",
  "block.minecraft.copper_torch": "Bakrena baklja",
  "block.minecraft.copper_trapdoor": "Bakrena podna vrata",
  "block.minecraft.copper_wall_torch": "Zidna bakrena baklja",
  "block.minecraft.cornflower": "Različak",
  "block.minecraft.cracked_deepslate_bricks": "Oštećene škriljave cigle",
  "block.minecraft.cracked_deepslate_tiles": "Oštećene škriljave pločice",
  "block.minecraft.cracked_nether_bricks": "Oštećene nether cigle",
  "block.minecraft.cracked_polished_blackstone_bricks": "Oštećene polirane cigle crnog kamena",
  "block.minecraft.cracked_stone_bricks": "Oštećene kamene cigle",
  "block.minecraft.crafter": "Radni blok",
  "block.minecraft.crafting_table": "Radni stol",
  "block.minecraft.creaking_heart": "Srce škripavca",
  "block.minecraft.creeper_head": "Glava creepera",
  "block.minecraft.creeper_wall_head": "Zidna glava creepera",
  "block.minecraft.crimson_button": "Grimizni gumb",
  "block.minecraft.crimson_door": "Grimizna vrata",
  "block.minecraft.crimson_fence": "Grimizna ograda",
  "block.minecraft.crimson_fence_gate": "Vrata za grimiznu ogradu",
  "block.minecraft.crimson_fungus": "Grimizna gljiva",
  "block.minecraft.crimson_hanging_sign": "Grimizni viseći znak",
  "block.minecraft.crimson_hyphae": "Grimizne hife",
  "block.minecraft.crimson_nylium": "Grimizni necelij",
  "block.minecraft.crimson_planks": "Grimizne daske",
  "block.minecraft.crimson_pressure_plate": "Grimizna nagazna ploča",
  "block.minecraft.crimson_roots": "Grimizno korijenje",
  "block.minecraft.crimson_shelf": "Grimizna polica",
  "block.minecraft.crimson_sign": "Grimizni znak",
  "block.minecraft.crimson_slab": "Grimizna ploča",
  "block.minecraft.crimson_stairs": "Grimizne stube",
  "block.minecraft.crimson_stem": "Grimizni stručak",
  "block.minecraft.crimson_trapdoor": "Grimizna podna vrata",
  "block.minecraft.crimson_wall_hanging_sign": "Grimizni viseći zidni znak",
  "block.minecraft.crimson_wall_sign": "Zidni grimizni znak",
  "block.minecraft.crying_obsidian": "Plačući opsidijan",
  "block.minecraft.cut_copper": "Rezani bakar",
  "block.minecraft.cut_copper_slab": "Ploča od rezanog bakra",
  "block.minecraft.cut_copper_stairs": "Stube od rezanog bakra",
  "block.minecraft.cut_red_sandstone": "Rezani crveni pješčenjak",
  "block.minecraft.cut_red_sandstone_slab": "Ploča od rezanog crvenog pješčenjaka",
  "block.minecraft.cut_sandstone": "Rezani pješčenjak",
  "block.minecraft.cut_sandstone_slab": "Ploča od rezanog pješčenjaka",
  "block.minecraft.cyan_banner": "Tirkizna zastava",
  "block.minecraft.cyan_bed": "Tirkizni krevet",
  "block.minecraft.cyan_candle": "Tirkizna svijeća",
  "block.minecraft.cyan_candle_cake": "Torta s tirkiznom svijećom",
  "block.minecraft.cyan_carpet": "Tirkizni tepih",
  "block.minecraft.cyan_concrete": "Tirkizni beton",
  "block.minecraft.cyan_concrete_powder": "Tirkizni prah betona",
  "block.minecraft.cyan_glazed_terracotta": "Tirkizna glazirana terakota",
  "block.minecraft.cyan_shulker_box": "Tirkizna shulker kutija",
  "block.minecraft.cyan_stained_glass": "Tirkizno staklo",
  "block.minecraft.cyan_stained_glass_pane": "Tirkizna staklena ploča",
  "block.minecraft.cyan_terracotta": "Tirkizna terakota",
  "block.minecraft.cyan_wool": "Tirkizna vuna",
  "block.minecraft.damaged_anvil": "Oštećen nakovanj",
  "block.minecraft.dandelion": "Maslačak",
  "block.minecraft.dark_oak_button": "Gumb od tamnog hrasta",
  "block.minecraft.dark_oak_door": "Vrata od tamnog hrasta",
  "block.minecraft.dark_oak_fence": "Ograda od tamnog hrasta",
  "block.minecraft.dark_oak_fence_gate": "Vrata za ogradu od tamnog hrasta",
  "block.minecraft.dark_oak_hanging_sign": "Viseći znak od tamnog hrasta",
  "block.minecraft.dark_oak_leaves": "Lišće tamnog hrasta",
  "block.minecraft.dark_oak_log": "Trupac tamnog hrasta",
  "block.minecraft.dark_oak_planks": "Daske od tamnog hrasta",
  "block.minecraft.dark_oak_pressure_plate": "Nagazna ploča od tamnog hrasta",
  "block.minecraft.dark_oak_sapling": "Mlado drvo tamnog hrasta",
  "block.minecraft.dark_oak_shelf": "Polica od tamnog hrasta",
  "block.minecraft.dark_oak_sign": "Znak od tamnog hrasta",
  "block.minecraft.dark_oak_slab": "Ploča od tamnog hrasta",
  "block.minecraft.dark_oak_stairs": "Stube od tamnog hrasta",
  "block.minecraft.dark_oak_trapdoor": "Podna vrata od tamnog hrasta",
  "block.minecraft.dark_oak_wall_hanging_sign": "Viseći zidni znak od tamnog hrasta",
  "block.minecraft.dark_oak_wall_sign": "Zidni znak od tamnog hrasta",
  "block.minecraft.dark_oak_wood": "Tamna hrastovina",
  "block.minecraft.dark_prismarine": "Tamni prizmarin",
  "block.minecraft.dark_prismarine_slab": "Ploča od tamnog prizmarina",
  "block.minecraft.dark_prismarine_stairs": "Stube od tamnog prizmarina",
  "block.minecraft.daylight_detector": "Detektor dnevnog svijetla",
  "block.minecraft.dead_brain_coral": "Mrtvi mozgov koralj",
  "block.minecraft.dead_brain_coral_block": "Blok mrtvog mozgovog koralja",
  "block.minecraft.dead_brain_coral_fan": "Mrtvi mozgov kožasti koralj",
  "block.minecraft.dead_brain_coral_wall_fan": "Mrtvi bočni mozgov kožasti koralj",
  "block.minecraft.dead_bubble_coral": "Mrtvi mjehuričasti koralj",
  "block.minecraft.dead_bubble_coral_block": "Blok mrtvog mjehuričastog koralja",
  "block.minecraft.dead_bubble_coral_fan": "Mrtvi mjehuričasti kožasti koralj",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mrtvi bočni mjehuričasti kožasti koralj",
  "block.minecraft.dead_bush": "Suhi grm",
  "block.minecraft.dead_fire_coral": "Mrtvi vatreni koralj",
  "block.minecraft.dead_fire_coral_block": "Blok mrtvog vatrenog koralja",
  "block.minecraft.dead_fire_coral_fan": "Mrtvi vatreni kožasti koralj",
  "block.minecraft.dead_fire_coral_wall_fan": "Mrtvi bočni vatreni kožasti koralj",
  "block.minecraft.dead_horn_coral": "Mrtvi rogasti koralj",
  "block.minecraft.dead_horn_coral_block": "Blok mrtvog rogastog koralja",
  "block.minecraft.dead_horn_coral_fan": "Mrtvi rogasti kožasti koralj",
  "block.minecraft.dead_horn_coral_wall_fan": "Mrtvi bočni rogasti kožasti koralj",
  "block.minecraft.dead_tube_coral": "Mrtvi cjevasti koralj",
  "block.minecraft.dead_tube_coral_block": "Blok mrtvog cjevastog koralja",
  "block.minecraft.dead_tube_coral_fan": "Mrtvi cjevasti kožasti koralj",
  "block.minecraft.dead_tube_coral_wall_fan": "Mrtvi bočni cjevasti kožasti koralj",
  "block.minecraft.decorated_pot": "Ukrašena lončanica",
  "block.minecraft.deepslate": "Škriljevac",
  "block.minecraft.deepslate_brick_slab": "Ploča od škriljavih cigala",
  "block.minecraft.deepslate_brick_stairs": "Stube od škriljavih cigala",
  "block.minecraft.deepslate_brick_wall": "Zid od škriljavih cigala",
  "block.minecraft.deepslate_bricks": "Škriljave cigle",
  "block.minecraft.deepslate_coal_ore": "Škriljava ugljena ruda",
  "block.minecraft.deepslate_copper_ore": "Škriljava bakrena ruda",
  "block.minecraft.deepslate_diamond_ore": "Škriljava dijamantna ruda",
  "block.minecraft.deepslate_emerald_ore": "Škriljava smaragdna ruda",
  "block.minecraft.deepslate_gold_ore": "Škriljava zlatna ruda",
  "block.minecraft.deepslate_iron_ore": "Škriljava željezna ruda",
  "block.minecraft.deepslate_lapis_ore": "Škriljava lazulitna ruda",
  "block.minecraft.deepslate_redstone_ore": "Škriljava redstone ruda",
  "block.minecraft.deepslate_tile_slab": "Ploča od škriljavih pločica",
  "block.minecraft.deepslate_tile_stairs": "Stube od škriljavih pločica",
  "block.minecraft.deepslate_tile_wall": "Zid od škriljavih pločica",
  "block.minecraft.deepslate_tiles": "Škriljave pločice",
  "block.minecraft.detector_rail": "Tračnice s detektorom",
  "block.minecraft.diamond_block": "Blok dijamanta",
  "block.minecraft.diamond_ore": "Dijamantna ruda",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Ploča od diorita",
  "block.minecraft.diorite_stairs": "Stube od diorita",
  "block.minecraft.diorite_wall": "Zid od diorita",
  "block.minecraft.dirt": "Zemlja",
  "block.minecraft.dirt_path": "Zemljani put",
  "block.minecraft.dispenser": "Streljač",
  "block.minecraft.dragon_egg": "Zmajevo jaje",
  "block.minecraft.dragon_head": "Glava zmaja",
  "block.minecraft.dragon_wall_head": "Zidna glava zmaja",
  "block.minecraft.dried_ghast": "Osušeni ghast",
  "block.minecraft.dried_kelp_block": "Blok osušenog kelpa",
  "block.minecraft.dripstone_block": "Blok speleotema",
  "block.minecraft.dropper": "Izbacivač",
  "block.minecraft.emerald_block": "Blok smaragda",
  "block.minecraft.emerald_ore": "Smaragdna ruda",
  "block.minecraft.enchanting_table": "Stol za čaranje",
  "block.minecraft.end_gateway": "End prolaz",
  "block.minecraft.end_portal": "End portal",
  "block.minecraft.end_portal_frame": "Okvir end portala",
  "block.minecraft.end_rod": "End štap",
  "block.minecraft.end_stone": "End kamen",
  "block.minecraft.end_stone_brick_slab": "Ploča od end kamenih cigala",
  "block.minecraft.end_stone_brick_stairs": "Stube od end kamenih cigala",
  "block.minecraft.end_stone_brick_wall": "Zid od end kamenih cigala",
  "block.minecraft.end_stone_bricks": "End kamene cigle",
  "block.minecraft.ender_chest": "Ender škrinja",
  "block.minecraft.exposed_chiseled_copper": "Izloženi isklesani bakar",
  "block.minecraft.exposed_copper": "Izloženi bakar",
  "block.minecraft.exposed_copper_bars": "Izložene bakrene šipke",
  "block.minecraft.exposed_copper_bulb": "Izložena bakrena žarulja",
  "block.minecraft.exposed_copper_chain": "Lanac od izloženog bakra",
  "block.minecraft.exposed_copper_chest": "Škrinja od izloženog bakra",
  "block.minecraft.exposed_copper_door": "Izložena bakrena vrata",
  "block.minecraft.exposed_copper_golem_statue": "Izloženi kip bakrenog golema",
  "block.minecraft.exposed_copper_grate": "Izložena bakrena rešetka",
  "block.minecraft.exposed_copper_lantern": "Svjetiljka od izloženog bakra",
  "block.minecraft.exposed_copper_trapdoor": "Izložena bakrena podna vrata",
  "block.minecraft.exposed_cut_copper": "Rezani izloženi bakar",
  "block.minecraft.exposed_cut_copper_slab": "Ploča od rezanog izloženog bakra",
  "block.minecraft.exposed_cut_copper_stairs": "Stube od rezanog izloženog bakra",
  "block.minecraft.exposed_lightning_rod": "Izloženi gromobran",
  "block.minecraft.farmland": "Obrađena zemlja",
  "block.minecraft.fern": "Paprat",
  "block.minecraft.fire": "Vatra",
  "block.minecraft.fire_coral": "Vatreni koralj",
  "block.minecraft.fire_coral_block": "Blok vatrenog koralja",
  "block.minecraft.fire_coral_fan": "Vatreni kožasti koralj",
  "block.minecraft.fire_coral_wall_fan": "Bočni vatreni kožasti koralj",
  "block.minecraft.firefly_bush": "Grm s krijesnicama",
  "block.minecraft.fletching_table": "Stol za streljaštvo",
  "block.minecraft.flower_pot": "Lončanica",
  "block.minecraft.flowering_azalea": "Cvatuća azaleja",
  "block.minecraft.flowering_azalea_leaves": "Cvatući azalejini listovi",
  "block.minecraft.frogspawn": "Žablja jaja",
  "block.minecraft.frosted_ice": "Krhki led",
  "block.minecraft.furnace": "Peć",
  "block.minecraft.gilded_blackstone": "Pozlaćeni crni kamen",
  "block.minecraft.glass": "Staklo",
  "block.minecraft.glass_pane": "Staklena ploča",
  "block.minecraft.glow_lichen": "Svjetleći lišaj",
  "block.minecraft.glowstone": "Svjetlucavi kamen",
  "block.minecraft.gold_block": "Blok zlata",
  "block.minecraft.gold_ore": "Zlatna ruda",
  "block.minecraft.golden_dandelion": "Zlatni maslačak",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Ploča od granita",
  "block.minecraft.granite_stairs": "Stube od granita",
  "block.minecraft.granite_wall": "Zid od granita",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Blok trave",
  "block.minecraft.gravel": "Šljunak",
  "block.minecraft.gray_banner": "Siva zastava",
  "block.minecraft.gray_bed": "Sivi krevet",
  "block.minecraft.gray_candle": "Siva svijeća",
  "block.minecraft.gray_candle_cake": "Torta sa sivom svijećom",
  "block.minecraft.gray_carpet": "Sivi tepih",
  "block.minecraft.gray_concrete": "Sivi beton",
  "block.minecraft.gray_concrete_powder": "Sivi prah betona",
  "block.minecraft.gray_glazed_terracotta": "Siva glazirana terakota",
  "block.minecraft.gray_shulker_box": "Siva shulker kutija",
  "block.minecraft.gray_stained_glass": "Sivo staklo",
  "block.minecraft.gray_stained_glass_pane": "Siva staklena ploča",
  "block.minecraft.gray_terracotta": "Siva terakota",
  "block.minecraft.gray_wool": "Siva vuna",
  "block.minecraft.green_banner": "Zelena zastava",
  "block.minecraft.green_bed": "Zeleni krevet",
  "block.minecraft.green_candle": "Zelena svijeća",
  "block.minecraft.green_candle_cake": "Torta sa zelenom svijećom",
  "block.minecraft.green_carpet": "Zeleni tepih",
  "block.minecraft.green_concrete": "Zeleni beton",
  "block.minecraft.green_concrete_powder": "Zeleni prah betona",
  "block.minecraft.green_glazed_terracotta": "Zelena glazirana terakota",
  "block.minecraft.green_shulker_box": "Zelena shulker kutija",
  "block.minecraft.green_stained_glass": "Zeleno staklo",
  "block.minecraft.green_stained_glass_pane": "Zelena staklena ploča",
  "block.minecraft.green_terracotta": "Zelena terakota",
  "block.minecraft.green_wool": "Zelena vuna",
  "block.minecraft.grindstone": "Brus",
  "block.minecraft.hanging_roots": "Viseće korijenje",
  "block.minecraft.hay_block": "Bala sijena",
  "block.minecraft.heavy_core": "Teška jezgra",
  "block.minecraft.heavy_weighted_pressure_plate": "Nagazna ploča teške osjetljivosti",
  "block.minecraft.honey_block": "Blok meda",
  "block.minecraft.honeycomb_block": "Blok saća",
  "block.minecraft.hopper": "Lijevak",
  "block.minecraft.horn_coral": "Rogasti koralj",
  "block.minecraft.horn_coral_block": "Blok rogastog koralja",
  "block.minecraft.horn_coral_fan": "Rogasti kožasti koralj",
  "block.minecraft.horn_coral_wall_fan": "Bočni rogasti kožasti koralj",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Zaražene isklesane kamene cigle",
  "block.minecraft.infested_cobblestone": "Zaraženi blok kaldrme",
  "block.minecraft.infested_cracked_stone_bricks": "Zaražene oštećene kamene cigle",
  "block.minecraft.infested_deepslate": "Zaraženi škriljevac",
  "block.minecraft.infested_mossy_stone_bricks": "Zaražene obrasle kamene cigle",
  "block.minecraft.infested_stone": "Zaraženi kamen",
  "block.minecraft.infested_stone_bricks": "Zaražene kamene cigle",
  "block.minecraft.iron_bars": "Željezne šipke",
  "block.minecraft.iron_block": "Blok željeza",
  "block.minecraft.iron_chain": "Lanac od željeza",
  "block.minecraft.iron_door": "Željezna vrata",
  "block.minecraft.iron_ore": "Željezna ruda",
  "block.minecraft.iron_trapdoor": "Željezna podna vrata",
  "block.minecraft.jack_o_lantern": "Svijetleća bundeva",
  "block.minecraft.jigsaw": "Blok slagalice",
  "block.minecraft.jukebox": "Glazbena kutija",
  "block.minecraft.jungle_button": "Gumb od prašumskog drva",
  "block.minecraft.jungle_door": "Vrata od prašumskog drva",
  "block.minecraft.jungle_fence": "Ograda od prašumskog drva",
  "block.minecraft.jungle_fence_gate": "Vrata za ogradu od prašumskog drva",
  "block.minecraft.jungle_hanging_sign": "Viseći znak od prašumskog drva",
  "block.minecraft.jungle_leaves": "Lišće prašumskog drveta",
  "block.minecraft.jungle_log": "Trupac prašumskog drveta",
  "block.minecraft.jungle_planks": "Daske od prašumskog drva",
  "block.minecraft.jungle_pressure_plate": "Nagazna ploča od prašumskog drva",
  "block.minecraft.jungle_sapling": "Mlado prašumsko drvo",
  "block.minecraft.jungle_shelf": "Polica od prašumskog drva",
  "block.minecraft.jungle_sign": "Znak od prašumskog drva",
  "block.minecraft.jungle_slab": "Ploča od prašumskog drva",
  "block.minecraft.jungle_stairs": "Stube od prašumskog drva",
  "block.minecraft.jungle_trapdoor": "Podna vrata od prašumskog drva",
  "block.minecraft.jungle_wall_hanging_sign": "Viseći zidni znak od prašumskog drva",
  "block.minecraft.jungle_wall_sign": "Zidni znak od prašumskog drva",
  "block.minecraft.jungle_wood": "Prašumsko drvo",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Biljka kelpa",
  "block.minecraft.ladder": "Ljestve",
  "block.minecraft.lantern": "Svjetiljka",
  "block.minecraft.lapis_block": "Blok lazulita",
  "block.minecraft.lapis_ore": "Lazulitna ruda",
  "block.minecraft.large_amethyst_bud": "Velika druza ametista",
  "block.minecraft.large_fern": "Velika paprat",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kotao s lavom",
  "block.minecraft.leaf_litter": "Lišće",
  "block.minecraft.lectern": "Pult",
  "block.minecraft.lever": "Poluga",
  "block.minecraft.light": "Svjetlo",
  "block.minecraft.light_blue_banner": "Svjetloplava zastava",
  "block.minecraft.light_blue_bed": "Svjetloplavi krevet",
  "block.minecraft.light_blue_candle": "Svjetloplava svijeća",
  "block.minecraft.light_blue_candle_cake": "Torta sa svjetloplavom svijećom",
  "block.minecraft.light_blue_carpet": "Svjetloplavi tepih",
  "block.minecraft.light_blue_concrete": "Svjetloplavi beton",
  "block.minecraft.light_blue_concrete_powder": "Svjetloplavi prah betona",
  "block.minecraft.light_blue_glazed_terracotta": "Svjetloplava glazirana terakota",
  "block.minecraft.light_blue_shulker_box": "Svjetloplava shulker kutija",
  "block.minecraft.light_blue_stained_glass": "Svjetloplavo staklo",
  "block.minecraft.light_blue_stained_glass_pane": "Svjetloplava staklena ploča",
  "block.minecraft.light_blue_terracotta": "Svjetloplava terakota",
  "block.minecraft.light_blue_wool": "Svjetloplava vuna",
  "block.minecraft.light_gray_banner": "Svjetlosiva zastava",
  "block.minecraft.light_gray_bed": "Svjetlosivi krevet",
  "block.minecraft.light_gray_candle": "Svjetlosiva svijeća",
  "block.minecraft.light_gray_candle_cake": "Torta sa svjetlosivom svijećom",
  "block.minecraft.light_gray_carpet": "Svjetlosivi tepih",
  "block.minecraft.light_gray_concrete": "Svjetlosivi beton",
  "block.minecraft.light_gray_concrete_powder": "Svjetlosivi prah betona",
  "block.minecraft.light_gray_glazed_terracotta": "Svjetlosiva glazirana terakota",
  "block.minecraft.light_gray_shulker_box": "Svjetlosiva shulker kutija",
  "block.minecraft.light_gray_stained_glass": "Svjetlosivo staklo",
  "block.minecraft.light_gray_stained_glass_pane": "Svjetlosiva staklena ploča",
  "block.minecraft.light_gray_terracotta": "Svjetlosiva terakota",
  "block.minecraft.light_gray_wool": "Svjetlosiva vuna",
  "block.minecraft.light_weighted_pressure_plate": "Nagazna ploča lakše osjetljivosti",
  "block.minecraft.lightning_rod": "Gromobran",
  "block.minecraft.lilac": "Jorgovan",
  "block.minecraft.lily_of_the_valley": "Đurđica",
  "block.minecraft.lily_pad": "Lopoč",
  "block.minecraft.lime_banner": "Svjetlozelena zastava",
  "block.minecraft.lime_bed": "Svjetlozeleni krevet",
  "block.minecraft.lime_candle": "Svjetlozelena svijeća",
  "block.minecraft.lime_candle_cake": "Torta sa svjetlozelenom svijećom",
  "block.minecraft.lime_carpet": "Svjetlozeleni tepih",
  "block.minecraft.lime_concrete": "Svjetlozeleni beton",
  "block.minecraft.lime_concrete_powder": "Svjetlozeleni prah betona",
  "block.minecraft.lime_glazed_terracotta": "Svjetlozelena glazirana terakota",
  "block.minecraft.lime_shulker_box": "Svjetlozelena shulker kutija",
  "block.minecraft.lime_stained_glass": "Svjetlozeleno staklo",
  "block.minecraft.lime_stained_glass_pane": "Svjetlozelena staklena ploča",
  "block.minecraft.lime_terracotta": "Svjetlozelena terakota",
  "block.minecraft.lime_wool": "Svjetlozelena vuna",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Tkalački stan",
  "block.minecraft.magenta_banner": "Roza zastava",
  "block.minecraft.magenta_bed": "Roza krevet",
  "block.minecraft.magenta_candle": "Roza svijeća",
  "block.minecraft.magenta_candle_cake": "Torta s roza svijećom",
  "block.minecraft.magenta_carpet": "Roza tepih",
  "block.minecraft.magenta_concrete": "Roza beton",
  "block.minecraft.magenta_concrete_powder": "Roza prah betona",
  "block.minecraft.magenta_glazed_terracotta": "Roza glazirana terakota",
  "block.minecraft.magenta_shulker_box": "Roza shulker kutija",
  "block.minecraft.magenta_stained_glass": "Roza staklo",
  "block.minecraft.magenta_stained_glass_pane": "Roza staklena ploča",
  "block.minecraft.magenta_terracotta": "Roza terakota",
  "block.minecraft.magenta_wool": "Roza vuna",
  "block.minecraft.magma_block": "Blok magme",
  "block.minecraft.mangrove_button": "Gumb od mangrova",
  "block.minecraft.mangrove_door": "Vrata od mangrova",
  "block.minecraft.mangrove_fence": "Ograda od mangrova",
  "block.minecraft.mangrove_fence_gate": "Vrata za ogradu od mangrova",
  "block.minecraft.mangrove_hanging_sign": "Viseći znak od mangrova",
  "block.minecraft.mangrove_leaves": "Lišće mangrova",
  "block.minecraft.mangrove_log": "Trupac mangrova",
  "block.minecraft.mangrove_planks": "Daske od mangrova",
  "block.minecraft.mangrove_pressure_plate": "Nagazna ploča od mangrova",
  "block.minecraft.mangrove_propagule": "Propagula mangrova",
  "block.minecraft.mangrove_roots": "Korijenje mangrova",
  "block.minecraft.mangrove_shelf": "Polica od mangrova",
  "block.minecraft.mangrove_sign": "Znak od mangrova",
  "block.minecraft.mangrove_slab": "Ploča od mangrova",
  "block.minecraft.mangrove_stairs": "Stube od mangrova",
  "block.minecraft.mangrove_trapdoor": "Podna vrata od mangrova",
  "block.minecraft.mangrove_wall_hanging_sign": "Viseći zidni znak od mangrova",
  "block.minecraft.mangrove_wall_sign": "Zidni znak od mangrova",
  "block.minecraft.mangrove_wood": "Drvo mangrova",
  "block.minecraft.medium_amethyst_bud": "Srednja druza ametista",
  "block.minecraft.melon": "Lubenica",
  "block.minecraft.melon_stem": "Stabljika lubenice",
  "block.minecraft.moss_block": "Blok mahovine",
  "block.minecraft.moss_carpet": "Tepih od mahovine",
  "block.minecraft.mossy_cobblestone": "Obrasli blok kaldrme",
  "block.minecraft.mossy_cobblestone_slab": "Ploča od obrasle kaldrme",
  "block.minecraft.mossy_cobblestone_stairs": "Stube od obrasle kaldrme",
  "block.minecraft.mossy_cobblestone_wall": "Zid od obrasle kaldrme",
  "block.minecraft.mossy_stone_brick_slab": "Ploča od obraslih kamenih cigala",
  "block.minecraft.mossy_stone_brick_stairs": "Stube od obraslih kamenih cigala",
  "block.minecraft.mossy_stone_brick_wall": "Zid od obraslih kamenih cigala",
  "block.minecraft.mossy_stone_bricks": "Obrasle kamene cigle",
  "block.minecraft.moving_piston": "Klip u kretanju",
  "block.minecraft.mud": "Blato",
  "block.minecraft.mud_brick_slab": "Ploča od ćerpiča",
  "block.minecraft.mud_brick_stairs": "Stube od ćerpiča",
  "block.minecraft.mud_brick_wall": "Zid od ćerpiča",
  "block.minecraft.mud_bricks": "Ćerpič",
  "block.minecraft.muddy_mangrove_roots": "Blatno korijenje mangrova",
  "block.minecraft.mushroom_stem": "Stručak gljive",
  "block.minecraft.mycelium": "Micelij",
  "block.minecraft.nether_brick_fence": "Ograda od nether cigala",
  "block.minecraft.nether_brick_slab": "Ploča od nether cigala",
  "block.minecraft.nether_brick_stairs": "Stube od nether cigala",
  "block.minecraft.nether_brick_wall": "Zid od nether cigala",
  "block.minecraft.nether_bricks": "Nether cigle",
  "block.minecraft.nether_gold_ore": "Nether zlatna ruda",
  "block.minecraft.nether_portal": "Nether portal",
  "block.minecraft.nether_quartz_ore": "Nether kvarcna ruda",
  "block.minecraft.nether_sprouts": "Nether klice",
  "block.minecraft.nether_wart": "Nether lišaj",
  "block.minecraft.nether_wart_block": "Blok nether lišaja",
  "block.minecraft.netherite_block": "Blok netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Glazbeni blok",
  "block.minecraft.oak_button": "Gumb od hrasta",
  "block.minecraft.oak_door": "Vrata od hrasta",
  "block.minecraft.oak_fence": "Ograda od hrasta",
  "block.minecraft.oak_fence_gate": "Vrata za ogradu od hrasta",
  "block.minecraft.oak_hanging_sign": "Viseći znak od hrasta",
  "block.minecraft.oak_leaves": "Lišće hrasta",
  "block.minecraft.oak_log": "Trupac hrasta",
  "block.minecraft.oak_planks": "Daske od hrasta",
  "block.minecraft.oak_pressure_plate": "Nagazna ploča od hrasta",
  "block.minecraft.oak_sapling": "Mlado drvo hrasta",
  "block.minecraft.oak_shelf": "Polica od hrasta",
  "block.minecraft.oak_sign": "Znak od hrasta",
  "block.minecraft.oak_slab": "Ploča od hrasta",
  "block.minecraft.oak_stairs": "Stube od hrasta",
  "block.minecraft.oak_trapdoor": "Podna vrata od hrasta",
  "block.minecraft.oak_wall_hanging_sign": "Viseći zidni znak od hrasta",
  "block.minecraft.oak_wall_sign": "Zidni znak od hrasta",
  "block.minecraft.oak_wood": "Hrastovina",
  "block.minecraft.observer": "Promatrač",
  "block.minecraft.obsidian": "Opsidijan",
  "block.minecraft.ochre_froglight": "Oker žabokrijes",
  "block.minecraft.ominous_banner": "Zlosutna zastava",
  "block.minecraft.open_eyeblossom": "Otvorena tratinčica",
  "block.minecraft.orange_banner": "Narančasta zastava",
  "block.minecraft.orange_bed": "Narančasti krevet",
  "block.minecraft.orange_candle": "Narančasta svijeća",
  "block.minecraft.orange_candle_cake": "Torta s narančastom svijećom",
  "block.minecraft.orange_carpet": "Narančasti tepih",
  "block.minecraft.orange_concrete": "Narančasti beton",
  "block.minecraft.orange_concrete_powder": "Narančasti prah betona",
  "block.minecraft.orange_glazed_terracotta": "Narančasta glazirana terakota",
  "block.minecraft.orange_shulker_box": "Narančasta shulker kutija",
  "block.minecraft.orange_stained_glass": "Narančasto staklo",
  "block.minecraft.orange_stained_glass_pane": "Narančasta staklena ploča",
  "block.minecraft.orange_terracotta": "Narančasta terakota",
  "block.minecraft.orange_tulip": "Narančasti tulipan",
  "block.minecraft.orange_wool": "Narančasta vuna",
  "block.minecraft.oxeye_daisy": "Tratinčica",
  "block.minecraft.oxidized_chiseled_copper": "Isklesani oksidirani bakar",
  "block.minecraft.oxidized_copper": "Oksidirani bakar",
  "block.minecraft.oxidized_copper_bars": "Oksidirane bakrene šipke",
  "block.minecraft.oxidized_copper_bulb": "Oksidirana bakrena lampa",
  "block.minecraft.oxidized_copper_chain": "Lanac od oksidiranog barka",
  "block.minecraft.oxidized_copper_chest": "Škrinja od oksidiranog bakra",
  "block.minecraft.oxidized_copper_door": "Oksidirana bakrena vrata",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidirani kip bakrenog golema",
  "block.minecraft.oxidized_copper_grate": "Oksidirana bakrena rešetka",
  "block.minecraft.oxidized_copper_lantern": "Svjetiljka od oksidiranog bakra",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidirana bakrena podna vrata",
  "block.minecraft.oxidized_cut_copper": "Rezani oksidirani bakar",
  "block.minecraft.oxidized_cut_copper_slab": "Ploča od rezanog oksidiranog bakra",
  "block.minecraft.oxidized_cut_copper_stairs": "Stube od rezanog oksidiranog bakra",
  "block.minecraft.oxidized_lightning_rod": "Oksidirani gromobran",
  "block.minecraft.packed_ice": "Tvrdi led",
  "block.minecraft.packed_mud": "Čvrsto blato",
  "block.minecraft.pale_hanging_moss": "Blijeda viseća mahovina",
  "block.minecraft.pale_moss_block": "Blijedi blok mahovine",
  "block.minecraft.pale_moss_carpet": "Blijedi tepih mahovine",
  "block.minecraft.pale_oak_button": "Gumb od blijedog hrasta",
  "block.minecraft.pale_oak_door": "Vrata od blijedog hrasta",
  "block.minecraft.pale_oak_fence": "Ograda od blijedog hrasta",
  "block.minecraft.pale_oak_fence_gate": "Vrata za ogradu od blijedog hrasta",
  "block.minecraft.pale_oak_hanging_sign": "Viseći znak od blijedog hrasta",
  "block.minecraft.pale_oak_leaves": "Lišće blijedog hrasta",
  "block.minecraft.pale_oak_log": "Trupac blijedog hrasta",
  "block.minecraft.pale_oak_planks": "Daske od blijedog hrasta",
  "block.minecraft.pale_oak_pressure_plate": "Potisna ploča od blijedog hrasta",
  "block.minecraft.pale_oak_sapling": "Sadnica blijedog hrasta",
  "block.minecraft.pale_oak_shelf": "Polica od blijedog hrasta",
  "block.minecraft.pale_oak_sign": "Znak od blijedog hrasta",
  "block.minecraft.pale_oak_slab": "Ploča od blijedog hrasta",
  "block.minecraft.pale_oak_stairs": "Stube od blijedog hrasta",
  "block.minecraft.pale_oak_trapdoor": "Podna vrata od blijedog hrasta",
  "block.minecraft.pale_oak_wall_hanging_sign": "Zidni viseći znak od blijedog hrasta",
  "block.minecraft.pale_oak_wall_sign": "Zidni znak od blijedog hrasta",
  "block.minecraft.pale_oak_wood": "Trupac blijedog hrasta",
  "block.minecraft.pearlescent_froglight": "Biserni žabokrijes",
  "block.minecraft.peony": "Božur",
  "block.minecraft.petrified_oak_slab": "Ploča od okamenjenog hrasta",
  "block.minecraft.piglin_head": "Glava piglina",
  "block.minecraft.piglin_wall_head": "Zidna glava piglina",
  "block.minecraft.pink_banner": "Ružičasta zastava",
  "block.minecraft.pink_bed": "Ružičasti krevet",
  "block.minecraft.pink_candle": "Ružičasta svijeća",
  "block.minecraft.pink_candle_cake": "Torta s ružičastom svijećom",
  "block.minecraft.pink_carpet": "Ružičasti tepih",
  "block.minecraft.pink_concrete": "Ružičasti beton",
  "block.minecraft.pink_concrete_powder": "Ružičasti prah betona",
  "block.minecraft.pink_glazed_terracotta": "Ružičasta glazirana terakota",
  "block.minecraft.pink_petals": "Ružičaste latice",
  "block.minecraft.pink_shulker_box": "Ružičasta shulker kutija",
  "block.minecraft.pink_stained_glass": "Ružičasto staklo",
  "block.minecraft.pink_stained_glass_pane": "Ružičasta staklena ploča",
  "block.minecraft.pink_terracotta": "Ružičasta terakota",
  "block.minecraft.pink_tulip": "Ružičasti tulipan",
  "block.minecraft.pink_wool": "Ružičasta vuna",
  "block.minecraft.piston": "Pokretni klip",
  "block.minecraft.piston_head": "Glava pokretnog klipa",
  "block.minecraft.pitcher_crop": "Usjev vrčonoše",
  "block.minecraft.pitcher_plant": "Vrčonoša",
  "block.minecraft.player_head": "Glava igrača",
  "block.minecraft.player_head.named": "Glava igrača „%s“",
  "block.minecraft.player_wall_head": "Zidna glava igrača",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Špiljska siga",
  "block.minecraft.polished_andesite": "Polirani andezit",
  "block.minecraft.polished_andesite_slab": "Ploča od poliranog andezita",
  "block.minecraft.polished_andesite_stairs": "Stube od poliranog andezita",
  "block.minecraft.polished_basalt": "Polirani bazalt",
  "block.minecraft.polished_blackstone": "Polirani crni kamen",
  "block.minecraft.polished_blackstone_brick_slab": "Polirana ploča od cigala crnog kamena",
  "block.minecraft.polished_blackstone_brick_stairs": "Polirane stube od cigala crnog kamena",
  "block.minecraft.polished_blackstone_brick_wall": "Zid od poliranih cigala crnog kamena",
  "block.minecraft.polished_blackstone_bricks": "Polirane cigle crnog kamena",
  "block.minecraft.polished_blackstone_button": "Polirani gumb od crnog kamena",
  "block.minecraft.polished_blackstone_pressure_plate": "Polirana nagazna ploča od crnog kamena",
  "block.minecraft.polished_blackstone_slab": "Polirana ploča od crnog kamena",
  "block.minecraft.polished_blackstone_stairs": "Polirane stube od crnog kamena",
  "block.minecraft.polished_blackstone_wall": "Zid od poliranog crnog kamena",
  "block.minecraft.polished_deepslate": "Polirani škriljevac",
  "block.minecraft.polished_deepslate_slab": "Ploča od poliranog škriljevca",
  "block.minecraft.polished_deepslate_stairs": "Stube od poliranog škriljevca",
  "block.minecraft.polished_deepslate_wall": "Zid od poliranog škriljevca",
  "block.minecraft.polished_diorite": "Polirani diorit",
  "block.minecraft.polished_diorite_slab": "Ploča od poliranog diorita",
  "block.minecraft.polished_diorite_stairs": "Stube od poliranog diorita",
  "block.minecraft.polished_granite": "Polirani granit",
  "block.minecraft.polished_granite_slab": "Ploča od poliranog granita",
  "block.minecraft.polished_granite_stairs": "Stube od poliranog granita",
  "block.minecraft.polished_tuff": "Polirani tuf",
  "block.minecraft.polished_tuff_slab": "Polirana ploča od tufa",
  "block.minecraft.polished_tuff_stairs": "Polirane stube od tufa",
  "block.minecraft.polished_tuff_wall": "Polirani zid of tufa",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Krumpiri",
  "block.minecraft.potted_acacia_sapling": "Mlado akacije u lončanici",
  "block.minecraft.potted_allium": "Ukrasni luk u lončanici",
  "block.minecraft.potted_azalea_bush": "Azaleja u lončanici",
  "block.minecraft.potted_azure_bluet": "Plava maćuhica u lončanici",
  "block.minecraft.potted_bamboo": "Bambus u lončanici",
  "block.minecraft.potted_birch_sapling": "Mlado breze u lončanici",
  "block.minecraft.potted_blue_orchid": "Plava orhideja u lončanici",
  "block.minecraft.potted_brown_mushroom": "Smeđa glijva u lončanici",
  "block.minecraft.potted_cactus": "Kaktus u lončanici",
  "block.minecraft.potted_cherry_sapling": "Mlado trešnje u lončanici",
  "block.minecraft.potted_closed_eyeblossom": "Tratinčica u cvjetnoj posudi",
  "block.minecraft.potted_cornflower": "Različak u lončanici",
  "block.minecraft.potted_crimson_fungus": "Grimizna gljiva u lončanici",
  "block.minecraft.potted_crimson_roots": "Grimizno korijenje u lončanici",
  "block.minecraft.potted_dandelion": "Maslačak u lončanici",
  "block.minecraft.potted_dark_oak_sapling": "Mlado tamnog hrasta u lončanici",
  "block.minecraft.potted_dead_bush": "Suhi grm u lončanici",
  "block.minecraft.potted_fern": "Paprat u lončanici",
  "block.minecraft.potted_flowering_azalea_bush": "Cvatuća azaleja u lončanici",
  "block.minecraft.potted_golden_dandelion": "Zlatni maslačak u lončanici",
  "block.minecraft.potted_jungle_sapling": "Mlado prašumskog drveta u lončanici",
  "block.minecraft.potted_lily_of_the_valley": "Đurđica u lončanici",
  "block.minecraft.potted_mangrove_propagule": "Propagula mangrova u lončanici",
  "block.minecraft.potted_oak_sapling": "Mlado hrasta u lončanici",
  "block.minecraft.potted_open_eyeblossom": "Otvorena tratinčica u cvjetnoj posudi",
  "block.minecraft.potted_orange_tulip": "Narančasti tulipan u lončanici",
  "block.minecraft.potted_oxeye_daisy": "Tratinčica u lončanici",
  "block.minecraft.potted_pale_oak_sapling": "Mlado blijedog hrasta u lončanici",
  "block.minecraft.potted_pink_tulip": "Ružičasti tulipan u lončanici",
  "block.minecraft.potted_poppy": "Mak u lončanici",
  "block.minecraft.potted_red_mushroom": "Crvena gljiva u lončanici",
  "block.minecraft.potted_red_tulip": "Crveni tulipan u lončanici",
  "block.minecraft.potted_spruce_sapling": "Mlado smreke u lončanici",
  "block.minecraft.potted_torchflower": "Bakljocvijet u lončanici",
  "block.minecraft.potted_warped_fungus": "Luda gljiva u lončanici",
  "block.minecraft.potted_warped_roots": "Ludo korijenje u lončanici",
  "block.minecraft.potted_white_tulip": "Bijeli tulipan u lončanici",
  "block.minecraft.potted_wither_rose": "Wither ruža u lončanici",
  "block.minecraft.powder_snow": "Snježni prah",
  "block.minecraft.powder_snow_cauldron": "Kotao sa snježnim prahom",
  "block.minecraft.powered_rail": "Tračnice s pogonom",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Ploča od prizmarinskih cigala",
  "block.minecraft.prismarine_brick_stairs": "Stube od prizmarinskih cigala",
  "block.minecraft.prismarine_bricks": "Cigle prizmarina",
  "block.minecraft.prismarine_slab": "Ploča od prizmarina",
  "block.minecraft.prismarine_stairs": "Stube od prizmarina",
  "block.minecraft.prismarine_wall": "Zid od prizmarina",
  "block.minecraft.pumpkin": "Bundeva",
  "block.minecraft.pumpkin_stem": "Stabljika bundeve",
  "block.minecraft.purple_banner": "Ljubičasta zastava",
  "block.minecraft.purple_bed": "Ljubičasti krevet",
  "block.minecraft.purple_candle": "Ljubičasta svijeća",
  "block.minecraft.purple_candle_cake": "Torta s ljubičastom svijećom",
  "block.minecraft.purple_carpet": "Ljubičasti tepih",
  "block.minecraft.purple_concrete": "Ljubičasti beton",
  "block.minecraft.purple_concrete_powder": "Ljubičasti prah betona",
  "block.minecraft.purple_glazed_terracotta": "Ljubičasta glazirana terakota",
  "block.minecraft.purple_shulker_box": "Ljubičasta shulker kutija",
  "block.minecraft.purple_stained_glass": "Ljubičasto staklo",
  "block.minecraft.purple_stained_glass_pane": "Ljubičasta staklena ploča",
  "block.minecraft.purple_terracotta": "Ljubičasta terakota",
  "block.minecraft.purple_wool": "Ljubičasta vuna",
  "block.minecraft.purpur_block": "Blok purpura",
  "block.minecraft.purpur_pillar": "Stup purpura",
  "block.minecraft.purpur_slab": "Ploča od purpura",
  "block.minecraft.purpur_stairs": "Stube od purpura",
  "block.minecraft.quartz_block": "Blok kvarca",
  "block.minecraft.quartz_bricks": "Kvarcne cigle",
  "block.minecraft.quartz_pillar": "Stup od kvarca",
  "block.minecraft.quartz_slab": "Ploča od kvarca",
  "block.minecraft.quartz_stairs": "Stube od kvarca",
  "block.minecraft.rail": "Tračnice",
  "block.minecraft.raw_copper_block": "Blok sirovog bakra",
  "block.minecraft.raw_gold_block": "Blok sirovog zlata",
  "block.minecraft.raw_iron_block": "Blok sirovog željeza",
  "block.minecraft.red_banner": "Crvena zastava",
  "block.minecraft.red_bed": "Crveni krevet",
  "block.minecraft.red_candle": "Crvena svijeća",
  "block.minecraft.red_candle_cake": "Torta s crvenom svijećom",
  "block.minecraft.red_carpet": "Crveni tepih",
  "block.minecraft.red_concrete": "Crveni beton",
  "block.minecraft.red_concrete_powder": "Crveni prah betona",
  "block.minecraft.red_glazed_terracotta": "Crvena glazirana terakota",
  "block.minecraft.red_mushroom": "Crvena gljiva",
  "block.minecraft.red_mushroom_block": "Blok crvene gljive",
  "block.minecraft.red_nether_brick_slab": "Ploča od crvenih nether cigala",
  "block.minecraft.red_nether_brick_stairs": "Stube od crvenih nether cigala",
  "block.minecraft.red_nether_brick_wall": "Zid od crvenih nether cigala",
  "block.minecraft.red_nether_bricks": "Crvene nether cigle",
  "block.minecraft.red_sand": "Crveni pijesak",
  "block.minecraft.red_sandstone": "Crveni pješčenjak",
  "block.minecraft.red_sandstone_slab": "Ploča od crvenog pješčenjaka",
  "block.minecraft.red_sandstone_stairs": "Stube od crvenog pješčenjaka",
  "block.minecraft.red_sandstone_wall": "Zid od crvenog pješčenjaka",
  "block.minecraft.red_shulker_box": "Crvena shulker kutija",
  "block.minecraft.red_stained_glass": "Crveno staklo",
  "block.minecraft.red_stained_glass_pane": "Crvena staklena ploča",
  "block.minecraft.red_terracotta": "Crvena terakota",
  "block.minecraft.red_tulip": "Crveni tulipan",
  "block.minecraft.red_wool": "Crvena vuna",
  "block.minecraft.redstone_block": "Blok redstona",
  "block.minecraft.redstone_lamp": "Redstone lampa",
  "block.minecraft.redstone_ore": "Redstone ruda",
  "block.minecraft.redstone_torch": "Redstone baklja",
  "block.minecraft.redstone_wall_torch": "Zidna redstone baklja",
  "block.minecraft.redstone_wire": "Redstone žica",
  "block.minecraft.reinforced_deepslate": "Armirani škriljevac",
  "block.minecraft.repeater": "Redstone repetitor",
  "block.minecraft.repeating_command_block": "Ponavljajući naredbeni blok",
  "block.minecraft.resin_block": "Blok smole",
  "block.minecraft.resin_brick_slab": "Ploča od smola cigli",
  "block.minecraft.resin_brick_stairs": "Stepenice od smola cigli",
  "block.minecraft.resin_brick_wall": "Zid od smola cigli",
  "block.minecraft.resin_bricks": "Smoline cigle",
  "block.minecraft.resin_clump": "Gruda smole",
  "block.minecraft.respawn_anchor": "Oltar preporođenja",
  "block.minecraft.rooted_dirt": "Ukorijenjena zemlja",
  "block.minecraft.rose_bush": "Grm ruža",
  "block.minecraft.sand": "Pijesak",
  "block.minecraft.sandstone": "Pješčenjak",
  "block.minecraft.sandstone_slab": "Ploča od pješčenjaka",
  "block.minecraft.sandstone_stairs": "Pješčane Stube",
  "block.minecraft.sandstone_wall": "Zid od pješčenjaka",
  "block.minecraft.scaffolding": "Skela",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Katalizator sculka",
  "block.minecraft.sculk_sensor": "Sculk senzor",
  "block.minecraft.sculk_shrieker": "Sculkov vrištač",
  "block.minecraft.sculk_vein": "Vene sculka",
  "block.minecraft.sea_lantern": "Podvodna svjetiljka",
  "block.minecraft.sea_pickle": "Morski krastavac",
  "block.minecraft.seagrass": "Morske cvjetnice",
  "block.minecraft.set_spawn": "Točka ponovnog stvaranja je postavljena",
  "block.minecraft.short_dry_grass": "Niska suha trava",
  "block.minecraft.short_grass": "Niska trava",
  "block.minecraft.shroomlight": "Svjetlogljiva",
  "block.minecraft.shulker_box": "Shulker kutija",
  "block.minecraft.skeleton_skull": "Lubanja",
  "block.minecraft.skeleton_wall_skull": "Zidna lubanja kostura",
  "block.minecraft.slime_block": "Ljigavi blok",
  "block.minecraft.small_amethyst_bud": "Mala druza ametista",
  "block.minecraft.small_dripleaf": "Mali kaplist",
  "block.minecraft.smithing_table": "Stol za kovanje",
  "block.minecraft.smoker": "Pušnica",
  "block.minecraft.smooth_basalt": "Glatki bazalt",
  "block.minecraft.smooth_quartz": "Blok od glatkog kvarca",
  "block.minecraft.smooth_quartz_slab": "Ploča od glatkog kvarca",
  "block.minecraft.smooth_quartz_stairs": "Stube od glatkog kvarca",
  "block.minecraft.smooth_red_sandstone": "Obrađeni crveni pješčenjak",
  "block.minecraft.smooth_red_sandstone_slab": "Ploča od glatkog crvenog pješčenjaka",
  "block.minecraft.smooth_red_sandstone_stairs": "Stube od glatkog crvenog pješčenjaka",
  "block.minecraft.smooth_sandstone": "Obrađeni pješčenjak",
  "block.minecraft.smooth_sandstone_slab": "Ploča od glatkog pješčenjaka",
  "block.minecraft.smooth_sandstone_stairs": "Stube od glatkog pješčenjaka",
  "block.minecraft.smooth_stone": "Glatki kamen",
  "block.minecraft.smooth_stone_slab": "Ploča od glatkog kamena",
  "block.minecraft.sniffer_egg": "Njuškovo jaje",
  "block.minecraft.snow": "Snijeg",
  "block.minecraft.snow_block": "Blok snijega",
  "block.minecraft.soul_campfire": "Logorska vatra živog plamena",
  "block.minecraft.soul_fire": "Živi plamen",
  "block.minecraft.soul_lantern": "Živa svjetiljka",
  "block.minecraft.soul_sand": "Živi pijesak",
  "block.minecraft.soul_soil": "Živa zemlja",
  "block.minecraft.soul_torch": "Živa baklja",
  "block.minecraft.soul_wall_torch": "Zidna živa baklja",
  "block.minecraft.spawn.not_valid": "Tvoj krevet ili napunjeni oltar preporođenja je uništen, ili ga nemaš",
  "block.minecraft.spawner": "Stvarač čudovišta",
  "block.minecraft.spawner.desc1": "Interakcija s jajetom za stvaranje:",
  "block.minecraft.spawner.desc2": "Postavlja vrstu stvorenja",
  "block.minecraft.sponge": "Spužva",
  "block.minecraft.spore_blossom": "Cvat spore",
  "block.minecraft.spruce_button": "Gumb od smreke",
  "block.minecraft.spruce_door": "Vrata od smreke",
  "block.minecraft.spruce_fence": "Ograda od smreke",
  "block.minecraft.spruce_fence_gate": "Vrata za ogradu od smreke",
  "block.minecraft.spruce_hanging_sign": "Viseći znak od smreke",
  "block.minecraft.spruce_leaves": "Lišće smreke",
  "block.minecraft.spruce_log": "Trupac smreke",
  "block.minecraft.spruce_planks": "Daske od smreke",
  "block.minecraft.spruce_pressure_plate": "Nagazna ploča od smreke",
  "block.minecraft.spruce_sapling": "Mlado drve smreke",
  "block.minecraft.spruce_shelf": "Polica od smreke",
  "block.minecraft.spruce_sign": "Znak od smreke",
  "block.minecraft.spruce_slab": "Ploča od smreke",
  "block.minecraft.spruce_stairs": "Stube od smreke",
  "block.minecraft.spruce_trapdoor": "Podna vrata od smreke",
  "block.minecraft.spruce_wall_hanging_sign": "Viseći zidni znak od smreke",
  "block.minecraft.spruce_wall_sign": "Zidni znak od smreke",
  "block.minecraft.spruce_wood": "Smrekovina",
  "block.minecraft.sticky_piston": "Ljepljivi pokretni klip",
  "block.minecraft.stone": "Kamen",
  "block.minecraft.stone_brick_slab": "Ploča od kamenih cigala",
  "block.minecraft.stone_brick_stairs": "Stube od kamenih cigala",
  "block.minecraft.stone_brick_wall": "Zid od kamenih cigala",
  "block.minecraft.stone_bricks": "Kamene cigle",
  "block.minecraft.stone_button": "Kameni gumb",
  "block.minecraft.stone_pressure_plate": "Kamena nagazna ploča",
  "block.minecraft.stone_slab": "Ploča od kamena",
  "block.minecraft.stone_stairs": "Stube od kamena",
  "block.minecraft.stonecutter": "Pila za rezanje kamena",
  "block.minecraft.stripped_acacia_log": "Oguljeni trupac akacije",
  "block.minecraft.stripped_acacia_wood": "Oguljeno drvo akacije",
  "block.minecraft.stripped_bamboo_block": "Blok oguljenog bambusa",
  "block.minecraft.stripped_birch_log": "Oguljeni trupac breze",
  "block.minecraft.stripped_birch_wood": "Oguljena brezovina",
  "block.minecraft.stripped_cherry_log": "Oguljeni trupac trešnje",
  "block.minecraft.stripped_cherry_wood": "Oguljena trešnjevina",
  "block.minecraft.stripped_crimson_hyphae": "Oguljene grimizne hife",
  "block.minecraft.stripped_crimson_stem": "Oguljeni grimizni stručak",
  "block.minecraft.stripped_dark_oak_log": "Oguljeni trupac tamnog hrasta",
  "block.minecraft.stripped_dark_oak_wood": "Oguljena tamna hrastovina",
  "block.minecraft.stripped_jungle_log": "Oguljeni trupac prašumskog drveta",
  "block.minecraft.stripped_jungle_wood": "Oguljeno drvo prašumskog drva",
  "block.minecraft.stripped_mangrove_log": "Ogoljeni trupac mangrova",
  "block.minecraft.stripped_mangrove_wood": "Ogoljeno drvo mangrova",
  "block.minecraft.stripped_oak_log": "Oguljeni trupac hrasta",
  "block.minecraft.stripped_oak_wood": "Oguljena hrastovina",
  "block.minecraft.stripped_pale_oak_log": "Oguljeni trupac blijedog hrasta",
  "block.minecraft.stripped_pale_oak_wood": "Oguljena blijeda hrastovina",
  "block.minecraft.stripped_spruce_log": "Oguljeni trupac smreke",
  "block.minecraft.stripped_spruce_wood": "Oguljeno drvo smreke",
  "block.minecraft.stripped_warped_hyphae": "Oguljene lude hife",
  "block.minecraft.stripped_warped_stem": "Oguljeni ludi stručak",
  "block.minecraft.structure_block": "Strukturni blok",
  "block.minecraft.structure_void": "Strukturna praznina",
  "block.minecraft.sugar_cane": "Šećerna trska",
  "block.minecraft.sunflower": "Suncokret",
  "block.minecraft.suspicious_gravel": "Sumnjivi šljunak",
  "block.minecraft.suspicious_sand": "Sumnjivi pijesak",
  "block.minecraft.sweet_berry_bush": "Grm slatkih bobica",
  "block.minecraft.tall_dry_grass": "Visoka suha trava",
  "block.minecraft.tall_grass": "Visoka trava",
  "block.minecraft.tall_seagrass": "Visoka Morska Trava",
  "block.minecraft.target": "Meta",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testni blok",
  "block.minecraft.test_instance_block": "Blok za ispitivanje",
  "block.minecraft.tinted_glass": "Zatamnjeno staklo",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Eksplozije TNT-a su onemogućene",
  "block.minecraft.torch": "Baklja",
  "block.minecraft.torchflower": "Bakljocvijet",
  "block.minecraft.torchflower_crop": "Usjev bakljocvijeta",
  "block.minecraft.trapped_chest": "Škrinja sa zamkom",
  "block.minecraft.trial_spawner": "Izazovni stvarač",
  "block.minecraft.tripwire": "Nagazna žica",
  "block.minecraft.tripwire_hook": "Kuka za nagaznu žicu",
  "block.minecraft.tube_coral": "Cjevasti koralj",
  "block.minecraft.tube_coral_block": "Blok cjevastog koralja",
  "block.minecraft.tube_coral_fan": "Cjevasti kožasti koralj",
  "block.minecraft.tube_coral_wall_fan": "Bočni cjevasti kožasti koralj",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Ploča od cigala od tufa",
  "block.minecraft.tuff_brick_stairs": "Stube od cigala od tufa",
  "block.minecraft.tuff_brick_wall": "Zid od cigala od tufa",
  "block.minecraft.tuff_bricks": "Cigle od tufa",
  "block.minecraft.tuff_slab": "Ploča od tufa",
  "block.minecraft.tuff_stairs": "Stube od tufa",
  "block.minecraft.tuff_wall": "Zid od tufa",
  "block.minecraft.turtle_egg": "Kornjačino jaje",
  "block.minecraft.twisting_vines": "Uvrnute lijane",
  "block.minecraft.twisting_vines_plant": "Biljka uvrnutih lijana",
  "block.minecraft.vault": "Trezor",
  "block.minecraft.verdant_froglight": "Zeleni žabokrijes",
  "block.minecraft.vine": "Lijane",
  "block.minecraft.void_air": "Zrak praznine",
  "block.minecraft.wall_torch": "Zidna baklja",
  "block.minecraft.warped_button": "Ludi gumb",
  "block.minecraft.warped_door": "Luda vrata",
  "block.minecraft.warped_fence": "Luda ograda",
  "block.minecraft.warped_fence_gate": "Vrata za ludu ogradu",
  "block.minecraft.warped_fungus": "Luda gljiva",
  "block.minecraft.warped_hanging_sign": "Ludi viseći znak",
  "block.minecraft.warped_hyphae": "Lude hife",
  "block.minecraft.warped_nylium": "Ludi necelij",
  "block.minecraft.warped_planks": "Lude daske",
  "block.minecraft.warped_pressure_plate": "Luda nagazna ploča",
  "block.minecraft.warped_roots": "Ludo korijenje",
  "block.minecraft.warped_shelf": "Luda polica",
  "block.minecraft.warped_sign": "Ludi znak",
  "block.minecraft.warped_slab": "Luda ploča",
  "block.minecraft.warped_stairs": "Lude stube",
  "block.minecraft.warped_stem": "Ludi stručak",
  "block.minecraft.warped_trapdoor": "Luda podna vrata",
  "block.minecraft.warped_wall_hanging_sign": "Ludi viseći zidni znak",
  "block.minecraft.warped_wall_sign": "Ludi zidni znak",
  "block.minecraft.warped_wart_block": "Blok ludog lišaja",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotao s vodom",
  "block.minecraft.waxed_chiseled_copper": "Isklesani voštani bakar",
  "block.minecraft.waxed_copper_bars": "Voštane bakrene šipke",
  "block.minecraft.waxed_copper_block": "Voštani bakreni blok",
  "block.minecraft.waxed_copper_bulb": "Voštana bakrena žarulja",
  "block.minecraft.waxed_copper_chain": "Lanac od voštanog bakra",
  "block.minecraft.waxed_copper_chest": "Škrinja od voštanog bakra",
  "block.minecraft.waxed_copper_door": "Voštana bakrena vrata",
  "block.minecraft.waxed_copper_golem_statue": "Voštani kip bakrenog golema",
  "block.minecraft.waxed_copper_grate": "Voštana bakrena rešetka",
  "block.minecraft.waxed_copper_lantern": "Svjetiljka od voštanog bakra",
  "block.minecraft.waxed_copper_trapdoor": "Voštana bakrena podna vrata",
  "block.minecraft.waxed_cut_copper": "Rezani voštani bakar",
  "block.minecraft.waxed_cut_copper_slab": "Voštana ploča od rezanog bakra",
  "block.minecraft.waxed_cut_copper_stairs": "Stube od rezanog voštanog bakra",
  "block.minecraft.waxed_exposed_chiseled_copper": "Isklesani izloženi voštani bakar",
  "block.minecraft.waxed_exposed_copper": "Izloženi voštani bakar",
  "block.minecraft.waxed_exposed_copper_bars": "Izložene voštane bakrene šipke",
  "block.minecraft.waxed_exposed_copper_bulb": "Izložena voštana bakrena žarulja",
  "block.minecraft.waxed_exposed_copper_chain": "Lanac od izloženog voštanog bakra",
  "block.minecraft.waxed_exposed_copper_chest": "Škrinja od izloženog voštanog bakra",
  "block.minecraft.waxed_exposed_copper_door": "Izložena voštana bakrena vrata",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Izloženi voštani kip bakrenog golema",
  "block.minecraft.waxed_exposed_copper_grate": "Izložena voštana bakrena rešetka",
  "block.minecraft.waxed_exposed_copper_lantern": "Svjetiljka od izloženog voštanog bakra",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Izložena voštana bakrena podna vrata",
  "block.minecraft.waxed_exposed_cut_copper": "Rezani izloženi voštani bakar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ploča od rezanog izloženog voštanog bakra",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Stube od rezanog izloženog voštanog bakra",
  "block.minecraft.waxed_exposed_lightning_rod": "Izloženi voštani gromobran",
  "block.minecraft.waxed_lightning_rod": "Voštani gromobran",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Isklesani oksidirani voštani bakar",
  "block.minecraft.waxed_oxidized_copper": "Oksidirani voštani bakar",
  "block.minecraft.waxed_oxidized_copper_bars": "Oksidirane voštane bakrene šipke",
  "block.minecraft.waxed_oxidized_copper_bulb": "Oksidirana voštana bakrena žarulja",
  "block.minecraft.waxed_oxidized_copper_chain": "Lanac od oksidiranog voštanog bakra",
  "block.minecraft.waxed_oxidized_copper_chest": "Škrinja od oksidiranog voštanog bakra",
  "block.minecraft.waxed_oxidized_copper_door": "Oksidirana voštana bakrena vrata",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Oksidirani voštani kip bakrenog golema",
  "block.minecraft.waxed_oxidized_copper_grate": "Oksidirana voštana bakrena rešetka",
  "block.minecraft.waxed_oxidized_copper_lantern": "Svjetiljka od oksidiranog voštanog bakra",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Oksidirana voštana bakrena podna vrata",
  "block.minecraft.waxed_oxidized_cut_copper": "Rezani oksidirani voštani bakar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ploča od rezanog oksidiranog voštanog bakra",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Stube od rezanog oksidiranog voštanog bakra",
  "block.minecraft.waxed_oxidized_lightning_rod": "Oksidirani voštani gromobran",
  "block.minecraft.waxed_weathered_chiseled_copper": "Isklesani istrošeni voštani bakar",
  "block.minecraft.waxed_weathered_copper": "Istrošeni voštani bakar",
  "block.minecraft.waxed_weathered_copper_bars": "Istrošene voštane bakrene šipke",
  "block.minecraft.waxed_weathered_copper_bulb": "Voštana istrošena bakrena žarulja",
  "block.minecraft.waxed_weathered_copper_chain": "Lanac od istrošenog voštanog bakra",
  "block.minecraft.waxed_weathered_copper_chest": "Škrinja od istrošenog voštanog bakra",
  "block.minecraft.waxed_weathered_copper_door": "Istrošena voštana bakrena vrata",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Istrošeni voštani kip bakrenog golema",
  "block.minecraft.waxed_weathered_copper_grate": "Istrošena voštana bakrena rešetka",
  "block.minecraft.waxed_weathered_copper_lantern": "Svjetiljka od istrošenog voštanog bakra",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Istrošena voštana bakrena podna vrata",
  "block.minecraft.waxed_weathered_cut_copper": "Rezani istrošeni voštani bakar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ploča od rezanog istrošenog voštanog bakra",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Stube od rezanog istrošenog voštanog bakra",
  "block.minecraft.waxed_weathered_lightning_rod": "Istrošeni voštani gromobran",
  "block.minecraft.weathered_chiseled_copper": "Isklesani istrošeni bakar",
  "block.minecraft.weathered_copper": "Istrošeni bakar",
  "block.minecraft.weathered_copper_bars": "Istrošene bakrene šipke",
  "block.minecraft.weathered_copper_bulb": "Istrošena bakrena žarulja",
  "block.minecraft.weathered_copper_chain": "Lanac od istrošenog bakra",
  "block.minecraft.weathered_copper_chest": "Škrinja od istrošenog bakra",
  "block.minecraft.weathered_copper_door": "Istrošena bakrena vrata",
  "block.minecraft.weathered_copper_golem_statue": "Istrošeni kip bakrenog golema",
  "block.minecraft.weathered_copper_grate": "Istrošena bakrena rešetka",
  "block.minecraft.weathered_copper_lantern": "Svjetiljka od istrošenog bakra",
  "block.minecraft.weathered_copper_trapdoor": "Istrošena bakrena podna vrata",
  "block.minecraft.weathered_cut_copper": "Rezani istrošeni bakar",
  "block.minecraft.weathered_cut_copper_slab": "Ploča od rezanog istrošenog bakra",
  "block.minecraft.weathered_cut_copper_stairs": "Stube od rezanog istrošenog bakra",
  "block.minecraft.weathered_lightning_rod": "Istrošeni gromobran",
  "block.minecraft.weeping_vines": "Tužne lijane",
  "block.minecraft.weeping_vines_plant": "Biljka tužnih lijana",
  "block.minecraft.wet_sponge": "Mokra spužva",
  "block.minecraft.wheat": "Usjevi pšenice",
  "block.minecraft.white_banner": "Bijela zastava",
  "block.minecraft.white_bed": "Bijeli krevet",
  "block.minecraft.white_candle": "Bijela svijeća",
  "block.minecraft.white_candle_cake": "Torta s bijelom svijećom",
  "block.minecraft.white_carpet": "Bijeli tepih",
  "block.minecraft.white_concrete": "Bijeli beton",
  "block.minecraft.white_concrete_powder": "Bijeli prah betona",
  "block.minecraft.white_glazed_terracotta": "Bijela glazirana terakota",
  "block.minecraft.white_shulker_box": "Bijela shulker kutija",
  "block.minecraft.white_stained_glass": "Bijelo staklo",
  "block.minecraft.white_stained_glass_pane": "Bijela staklena ploča",
  "block.minecraft.white_terracotta": "Bijela terakota",
  "block.minecraft.white_tulip": "Bijeli tulipan",
  "block.minecraft.white_wool": "Bijela vuna",
  "block.minecraft.wildflowers": "Divlje cvijeće",
  "block.minecraft.wither_rose": "Wither ruža",
  "block.minecraft.wither_skeleton_skull": "Lubanja Wither kostura",
  "block.minecraft.wither_skeleton_wall_skull": "Zidna lubanja Wither kostura",
  "block.minecraft.yellow_banner": "Žuta zastava",
  "block.minecraft.yellow_bed": "Žuti krevet",
  "block.minecraft.yellow_candle": "Žuta svijeća",
  "block.minecraft.yellow_candle_cake": "Torta sa žutom svijećom",
  "block.minecraft.yellow_carpet": "Žuti tepih",
  "block.minecraft.yellow_concrete": "Žuti beton",
  "block.minecraft.yellow_concrete_powder": "Žuti prah betona",
  "block.minecraft.yellow_glazed_terracotta": "Žuta glazirana terakota",
  "block.minecraft.yellow_shulker_box": "Žuta shulker kutija",
  "block.minecraft.yellow_stained_glass": "Žuto staklo",
  "block.minecraft.yellow_stained_glass_pane": "Žuta staklena ploča",
  "block.minecraft.yellow_terracotta": "Žuta terakota",
  "block.minecraft.yellow_wool": "Žuta vuna",
  "block.minecraft.zombie_head": "Glava zombija",
  "block.minecraft.zombie_wall_head": "Zidna glava zombija",
  "item.minecraft.acacia_boat": "Čamac od akacije",
  "item.minecraft.acacia_chest_boat": "Čamac od akacije sa škrinjom",
  "item.minecraft.allay_spawn_egg": "Jaje za stvaranje plavka",
  "item.minecraft.amethyst_shard": "Krhotina ametista",
  "item.minecraft.angler_pottery_shard": "Krhotina lončanice ribič",
  "item.minecraft.angler_pottery_sherd": "Krhotina lončanice ribič",
  "item.minecraft.apple": "Jabuka",
  "item.minecraft.archer_pottery_shard": "Krhotina lončanice strijelac",
  "item.minecraft.archer_pottery_sherd": "Krhotina lončanice strijelac",
  "item.minecraft.armadillo_scute": "Ljuska pasanca",
  "item.minecraft.armadillo_spawn_egg": "Jaje za stvaranje pasanca",
  "item.minecraft.armor_stand": "Postolje za oklop",
  "item.minecraft.arms_up_pottery_shard": "Krhotina lončanice zabava",
  "item.minecraft.arms_up_pottery_sherd": "Krhotina lončanice zabava",
  "item.minecraft.arrow": "Strijela",
  "item.minecraft.axolotl_bucket": "Kanta s aksolotlom",
  "item.minecraft.axolotl_spawn_egg": "Jaje za stvaranje aksolotla",
  "item.minecraft.baked_potato": "Pečeni krumpir",
  "item.minecraft.bamboo_chest_raft": "Splav od bambusa sa škrinjom",
  "item.minecraft.bamboo_raft": "Splav od bambusa",
  "item.minecraft.bat_spawn_egg": "Jaje za stvaranje šišmiša",
  "item.minecraft.bee_spawn_egg": "Jaje za stvaranje pčele",
  "item.minecraft.beef": "Sirova govedina",
  "item.minecraft.beetroot": "Cikla",
  "item.minecraft.beetroot_seeds": "Sjemenke cikle",
  "item.minecraft.beetroot_soup": "Juha od cikle",
  "item.minecraft.birch_boat": "Čamac od breze",
  "item.minecraft.birch_chest_boat": "Čamac od breze sa škrinjom",
  "item.minecraft.black_bundle": "Crni svežanj",
  "item.minecraft.black_dye": "Crna boja",
  "item.minecraft.black_harness": "Crna orma",
  "item.minecraft.blade_pottery_shard": "Krhotina lončanice oštrica",
  "item.minecraft.blade_pottery_sherd": "Krhotina lončanice oštrica",
  "item.minecraft.blaze_powder": "Bljeskov prah",
  "item.minecraft.blaze_rod": "Bljeskov štap",
  "item.minecraft.blaze_spawn_egg": "Jaje za stvaranje bljeska",
  "item.minecraft.blue_bundle": "Plavi svežanj",
  "item.minecraft.blue_dye": "Plava boja",
  "item.minecraft.blue_egg": "Zeleno jaje",
  "item.minecraft.blue_harness": "Plava orma",
  "item.minecraft.bogged_spawn_egg": "Jaje za stvaranje močvarnika",
  "item.minecraft.bolt_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Oklopni ukras vijak",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Koštano brašno",
  "item.minecraft.book": "Knjiga",
  "item.minecraft.bordure_indented_banner_pattern": "Ograniči uvučeni uzorak barjaka",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Zdjela",
  "item.minecraft.bread": "Kruh",
  "item.minecraft.breeze_rod": "Lahorov štap",
  "item.minecraft.breeze_spawn_egg": "Jaje za stvaranje lahora",
  "item.minecraft.brewer_pottery_shard": "Krhotina lončanice napitak",
  "item.minecraft.brewer_pottery_sherd": "Krhotina lončanice napitak",
  "item.minecraft.brewing_stand": "Postolje za napitke",
  "item.minecraft.brick": "Cigla",
  "item.minecraft.brown_bundle": "Smeđi svežanj",
  "item.minecraft.brown_dye": "Smeđa boja",
  "item.minecraft.brown_egg": "Smeđe jaje",
  "item.minecraft.brown_harness": "Smeđa orma",
  "item.minecraft.brush": "Kist",
  "item.minecraft.bucket": "Kanta",
  "item.minecraft.bundle": "Svežanj",
  "item.minecraft.bundle.empty": "Prazan",
  "item.minecraft.bundle.empty.description": "Može sadržavati raznovrsne stvari",
  "item.minecraft.bundle.full": "Pun",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Krhotina lončanice požar",
  "item.minecraft.burn_pottery_sherd": "Krhotina lončanice požar",
  "item.minecraft.camel_husk_spawn_egg": "Jaje za stvaranje zombi deve",
  "item.minecraft.camel_spawn_egg": "Jaje za stvaranje deve",
  "item.minecraft.carrot": "Mrkva",
  "item.minecraft.carrot_on_a_stick": "Mrkva na štapu",
  "item.minecraft.cat_spawn_egg": "Jaje za stvaranje mačke",
  "item.minecraft.cauldron": "Kotao",
  "item.minecraft.cave_spider_spawn_egg": "Jaje za stvaranje špiljskog pauka",
  "item.minecraft.chainmail_boots": "Lančane čizme",
  "item.minecraft.chainmail_chestplate": "Lančani prsni oklop",
  "item.minecraft.chainmail_helmet": "Lančani šljem",
  "item.minecraft.chainmail_leggings": "Lančane gamaše",
  "item.minecraft.charcoal": "Drveni ugljen",
  "item.minecraft.cherry_boat": "Čamac od trešnje",
  "item.minecraft.cherry_chest_boat": "Čamac od trešnje sa škrinjom",
  "item.minecraft.chest_minecart": "Vagon sa škrinjom",
  "item.minecraft.chicken": "Sirova piletina",
  "item.minecraft.chicken_spawn_egg": "Jaje za stvaranje kokoši",
  "item.minecraft.chorus_fruit": "Voće chorusa",
  "item.minecraft.clay_ball": "Glinena kuglica",
  "item.minecraft.clock": "Sat",
  "item.minecraft.coal": "Ugljen",
  "item.minecraft.coast_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Oklopno set Obala",
  "item.minecraft.cocoa_beans": "Sjemenke kakaa",
  "item.minecraft.cod": "Sirovi bakalar",
  "item.minecraft.cod_bucket": "Kanta s bakalarom",
  "item.minecraft.cod_spawn_egg": "Jaje za stvaranje bakalara",
  "item.minecraft.command_block_minecart": "Vagon s naredbenim blokom",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Odrezak",
  "item.minecraft.cooked_chicken": "Pečena piletina",
  "item.minecraft.cooked_cod": "Kuhani bakalar",
  "item.minecraft.cooked_mutton": "Pečena janjetina",
  "item.minecraft.cooked_porkchop": "Pečena svinjetina",
  "item.minecraft.cooked_rabbit": "Pečena zečetina",
  "item.minecraft.cooked_salmon": "Kuhani losos",
  "item.minecraft.cookie": "Kolačić",
  "item.minecraft.copper_axe": "Bakrena sjekira",
  "item.minecraft.copper_boots": "Bakrene čizme",
  "item.minecraft.copper_chestplate": "Bakreni prsni oklop",
  "item.minecraft.copper_golem_spawn_egg": "Jaje za stvaranje bakrenog golema",
  "item.minecraft.copper_helmet": "Bakrena kaciga",
  "item.minecraft.copper_hoe": "Bakrena motika",
  "item.minecraft.copper_horse_armor": "Bakreni konjski oklop",
  "item.minecraft.copper_ingot": "Bakrena poluga",
  "item.minecraft.copper_leggings": "Bakrene gamaše",
  "item.minecraft.copper_nautilus_armor": "Bakreni oklop nautilusa",
  "item.minecraft.copper_nugget": "Grumen bakra",
  "item.minecraft.copper_pickaxe": "Bakreni kramp",
  "item.minecraft.copper_shovel": "Bakrena lopata",
  "item.minecraft.copper_spear": "Bakreno koplje",
  "item.minecraft.copper_sword": "Bakreni mač",
  "item.minecraft.cow_spawn_egg": "Jaje za stvaranje krave",
  "item.minecraft.creaking_spawn_egg": "Jaje za stvaranje škripavca",
  "item.minecraft.creeper_banner_pattern": "Uzorak zastave",
  "item.minecraft.creeper_banner_pattern.desc": "Lik creepera",
  "item.minecraft.creeper_banner_pattern.new": "Jezivi Naboj uzorak barjaka",
  "item.minecraft.creeper_spawn_egg": "Jaje za stvaranje creepera",
  "item.minecraft.crossbow": "Samostrijel",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Projektil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projektil: %s",
  "item.minecraft.cyan_bundle": "Tirkizni svežanj",
  "item.minecraft.cyan_dye": "Tirkizna boja",
  "item.minecraft.cyan_harness": "Tirkizna orma",
  "item.minecraft.danger_pottery_shard": "Krhotina lončanice opasnost",
  "item.minecraft.danger_pottery_sherd": "Krhotina lončanice opasnost",
  "item.minecraft.dark_oak_boat": "Čamac od tamnog hrasta",
  "item.minecraft.dark_oak_chest_boat": "Čamac od tamnog hrasta sa škrinjom",
  "item.minecraft.debug_stick": "Štap otklanjanja grešaka",
  "item.minecraft.debug_stick.empty": "%s nema postavki",
  "item.minecraft.debug_stick.select": "odabrano „%s“ (%s)",
  "item.minecraft.debug_stick.update": "„%s“ na %s",
  "item.minecraft.diamond": "Dijamant",
  "item.minecraft.diamond_axe": "Dijamantna sjekira",
  "item.minecraft.diamond_boots": "Dijamantne čizme",
  "item.minecraft.diamond_chestplate": "Dijamantni prsni oklop",
  "item.minecraft.diamond_helmet": "Dijamantni šljem",
  "item.minecraft.diamond_hoe": "Dijamantna motika",
  "item.minecraft.diamond_horse_armor": "Dijamantni konjski oklop",
  "item.minecraft.diamond_leggings": "Dijamantne gamaše",
  "item.minecraft.diamond_nautilus_armor": "Dijamantni oklop nautilusa",
  "item.minecraft.diamond_pickaxe": "Dijamantni kramp",
  "item.minecraft.diamond_shovel": "Dijamantna lopata",
  "item.minecraft.diamond_spear": "Dijamantno koplje",
  "item.minecraft.diamond_sword": "Dijamantni mač",
  "item.minecraft.disc_fragment_5": "Komad diska",
  "item.minecraft.disc_fragment_5.desc": "Glazbeni disk – 5",
  "item.minecraft.dolphin_spawn_egg": "Jaje za stvaranje dupina",
  "item.minecraft.donkey_spawn_egg": "Jaje za stvaranje magarca",
  "item.minecraft.dragon_breath": "Zmajev dah",
  "item.minecraft.dried_kelp": "Osušeni kelp",
  "item.minecraft.drowned_spawn_egg": "Jaje za stvaranje utopljenika",
  "item.minecraft.dune_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Oklopni set Dina",
  "item.minecraft.echo_shard": "Krhotina jeke",
  "item.minecraft.egg": "Jaje",
  "item.minecraft.elder_guardian_spawn_egg": "Jaje za stvaranje drevnog čuvara",
  "item.minecraft.elytra": "Elitre",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Začarana knjiga",
  "item.minecraft.enchanted_golden_apple": "Začarana zlatna jabuka",
  "item.minecraft.end_crystal": "End kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Jaje za stvaranje Ender zmaja",
  "item.minecraft.ender_eye": "Oko endera",
  "item.minecraft.ender_pearl": "Ender biser",
  "item.minecraft.enderman_spawn_egg": "Jaje za stvaranje endermana",
  "item.minecraft.endermite_spawn_egg": "Jaje za stvaranje endermita",
  "item.minecraft.evoker_spawn_egg": "Jaje za stvaranje prizivatelja",
  "item.minecraft.experience_bottle": "Bočica čarolije",
  "item.minecraft.explorer_pottery_shard": "Krhotina lončanice istraživač",
  "item.minecraft.explorer_pottery_sherd": "Krhotina lončanice istraživač",
  "item.minecraft.eye_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Oklopni set Oko",
  "item.minecraft.feather": "Pero",
  "item.minecraft.fermented_spider_eye": "Fermentirano paukovo oko",
  "item.minecraft.field_masoned_banner_pattern": "Cigleno polje uzorak barjaka",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Vatrena kugla",
  "item.minecraft.firework_rocket": "Vatrometna raketa",
  "item.minecraft.firework_rocket.flight": "Duljina leta:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Vatrometna zvijezda",
  "item.minecraft.firework_star.black": "Crna",
  "item.minecraft.firework_star.blue": "Plava",
  "item.minecraft.firework_star.brown": "Smeđa",
  "item.minecraft.firework_star.custom_color": "Prilagođena",
  "item.minecraft.firework_star.cyan": "Tirkizna",
  "item.minecraft.firework_star.fade_to": "Nestati do",
  "item.minecraft.firework_star.flicker": "Svjetlucanje",
  "item.minecraft.firework_star.gray": "Siva",
  "item.minecraft.firework_star.green": "Zelena",
  "item.minecraft.firework_star.light_blue": "Svjetloplava",
  "item.minecraft.firework_star.light_gray": "Svjetlosiva",
  "item.minecraft.firework_star.lime": "Svjetlozelena",
  "item.minecraft.firework_star.magenta": "Roza",
  "item.minecraft.firework_star.orange": "Narančasta",
  "item.minecraft.firework_star.pink": "Ružičasta",
  "item.minecraft.firework_star.purple": "Ljubičasta",
  "item.minecraft.firework_star.red": "Crvena",
  "item.minecraft.firework_star.shape": "Nepoznat oblik",
  "item.minecraft.firework_star.shape.burst": "Prasak",
  "item.minecraft.firework_star.shape.creeper": "Oblik creepera",
  "item.minecraft.firework_star.shape.large_ball": "Velika kugla",
  "item.minecraft.firework_star.shape.small_ball": "Mala kugla",
  "item.minecraft.firework_star.shape.star": "Zvjezdani oblik",
  "item.minecraft.firework_star.trail": "Trag",
  "item.minecraft.firework_star.white": "Bijela",
  "item.minecraft.firework_star.yellow": "Žuta",
  "item.minecraft.fishing_rod": "Štap za pecanje",
  "item.minecraft.flint": "Kremen",
  "item.minecraft.flint_and_steel": "Kremen i čelik",
  "item.minecraft.flow_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Oklopni set Tok",
  "item.minecraft.flow_banner_pattern": "Uzorak zastave",
  "item.minecraft.flow_banner_pattern.desc": "Vrtlog",
  "item.minecraft.flow_banner_pattern.new": "Uzorak zastave vrtlog",
  "item.minecraft.flow_pottery_sherd": "Krhotina lončanice vrtlog",
  "item.minecraft.flower_banner_pattern": "Uzorak zastave",
  "item.minecraft.flower_banner_pattern.desc": "Lik cvijeta",
  "item.minecraft.flower_banner_pattern.new": "Uzorak zastave lik cvijeta",
  "item.minecraft.flower_pot": "Lončanica",
  "item.minecraft.fox_spawn_egg": "Jaje za stvaranje lisice",
  "item.minecraft.friend_pottery_shard": "Krhotina lončanice prijatelj",
  "item.minecraft.friend_pottery_sherd": "Krhotina lončanice prijatelj",
  "item.minecraft.frog_spawn_egg": "Jaje za stvaranje žabe",
  "item.minecraft.furnace_minecart": "Vagon s peći",
  "item.minecraft.ghast_spawn_egg": "Jaje za stvaranje ghasta",
  "item.minecraft.ghast_tear": "Suza ghasta",
  "item.minecraft.glass_bottle": "Staklena bočica",
  "item.minecraft.glistering_melon_slice": "Sjajna kriška lubenice",
  "item.minecraft.globe_banner_pattern": "Uzorak zastave",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Uzorak zastave globus",
  "item.minecraft.glow_berries": "Svjetleće bobice",
  "item.minecraft.glow_ink_sac": "Svjetleća tinta",
  "item.minecraft.glow_item_frame": "Svjetleći okvir",
  "item.minecraft.glow_squid_spawn_egg": "Jaje za stvaranje svjetleće lignje",
  "item.minecraft.glowstone_dust": "Svjetlucava prašina",
  "item.minecraft.goat_horn": "Kozji rog",
  "item.minecraft.goat_spawn_egg": "Jaje za stvaranje koze",
  "item.minecraft.gold_ingot": "Zlatna poluga",
  "item.minecraft.gold_nugget": "Grumen zlata",
  "item.minecraft.golden_apple": "Zlatna jabuka",
  "item.minecraft.golden_axe": "Zlatna sjekira",
  "item.minecraft.golden_boots": "Zlatne čizme",
  "item.minecraft.golden_carrot": "Zlatna mrkva",
  "item.minecraft.golden_chestplate": "Zlatni prsni oklop",
  "item.minecraft.golden_helmet": "Zlatni šljem",
  "item.minecraft.golden_hoe": "Zlatna motika",
  "item.minecraft.golden_horse_armor": "Zlatni konjski oklop",
  "item.minecraft.golden_leggings": "Zlatne gamaše",
  "item.minecraft.golden_nautilus_armor": "Zlatni oklop nautilusa",
  "item.minecraft.golden_pickaxe": "Zlatni kramp",
  "item.minecraft.golden_shovel": "Zlatna lopata",
  "item.minecraft.golden_spear": "Zlatno koplje",
  "item.minecraft.golden_sword": "Zlatni mač",
  "item.minecraft.gray_bundle": "Sivi svežanj",
  "item.minecraft.gray_dye": "Siva boja",
  "item.minecraft.gray_harness": "Siva orma",
  "item.minecraft.green_bundle": "Zeleni svežanj",
  "item.minecraft.green_dye": "Zelena boja",
  "item.minecraft.green_harness": "Zelena orma",
  "item.minecraft.guardian_spawn_egg": "Jaje za stvaranje čuvara",
  "item.minecraft.gunpowder": "Barut",
  "item.minecraft.guster_banner_pattern": "Uzorak zastave",
  "item.minecraft.guster_banner_pattern.desc": "Zapuh",
  "item.minecraft.guster_banner_pattern.new": "Uzorak zastave zapuh",
  "item.minecraft.guster_pottery_sherd": "Krhotina lončanice zapuh",
  "item.minecraft.happy_ghast_spawn_egg": "Jaje za stvaranje veselog ghasta",
  "item.minecraft.harness": "Orma",
  "item.minecraft.heart_of_the_sea": "Srce mora",
  "item.minecraft.heart_pottery_shard": "Krhotina lončanice srce",
  "item.minecraft.heart_pottery_sherd": "Krhotina lončanice srce",
  "item.minecraft.heartbreak_pottery_shard": "Krhotina lončanice srcolom",
  "item.minecraft.heartbreak_pottery_sherd": "Krhotina lončanice srcolom",
  "item.minecraft.hoglin_spawn_egg": "Jaje za stvaranje hoglina",
  "item.minecraft.honey_bottle": "Bočica meda",
  "item.minecraft.honeycomb": "Saće",
  "item.minecraft.hopper_minecart": "Vagon s lijevkom",
  "item.minecraft.horse_spawn_egg": "Jaje za stvaranje konja",
  "item.minecraft.host_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.host_armor_trim_smithing_template.new": "Oklopni ukras domaćin",
  "item.minecraft.howl_pottery_shard": "Krhotina lončanice lavež",
  "item.minecraft.howl_pottery_sherd": "Krhotina lončanice lavež",
  "item.minecraft.husk_spawn_egg": "Jaje za stvaranje pustinjskog zombija",
  "item.minecraft.ink_sac": "Crna tinta",
  "item.minecraft.iron_axe": "Željezna sjekira",
  "item.minecraft.iron_boots": "Željezne čizme",
  "item.minecraft.iron_chestplate": "Željezni prsni oklop",
  "item.minecraft.iron_golem_spawn_egg": "Jaje za stvaranje željeznog čuvara",
  "item.minecraft.iron_helmet": "Željezni šljem",
  "item.minecraft.iron_hoe": "Željezna motika",
  "item.minecraft.iron_horse_armor": "Željezni konjski oklop",
  "item.minecraft.iron_ingot": "Željezna poluga",
  "item.minecraft.iron_leggings": "Željezne gamaše",
  "item.minecraft.iron_nautilus_armor": "Željezni oklop nautilusa",
  "item.minecraft.iron_nugget": "Grumen željeza",
  "item.minecraft.iron_pickaxe": "Željezni kramp",
  "item.minecraft.iron_shovel": "Željezna lopata",
  "item.minecraft.iron_spear": "Željezno koplje",
  "item.minecraft.iron_sword": "Željezni mač",
  "item.minecraft.item_frame": "Okvir",
  "item.minecraft.jungle_boat": "Čamac od prašumskog drva",
  "item.minecraft.jungle_chest_boat": "Čamac od prašumskog drva sa škrinjom",
  "item.minecraft.knowledge_book": "Knjiga znanja",
  "item.minecraft.lapis_lazuli": "Lazulit",
  "item.minecraft.lava_bucket": "Kanta s lavom",
  "item.minecraft.lead": "Povodac",
  "item.minecraft.leather": "Koža",
  "item.minecraft.leather_boots": "Kožne čizme",
  "item.minecraft.leather_chestplate": "Kožna tunika",
  "item.minecraft.leather_helmet": "Kožna kapa",
  "item.minecraft.leather_horse_armor": "Kožni konjski oklop",
  "item.minecraft.leather_leggings": "Kožne hlače",
  "item.minecraft.light_blue_bundle": "Svjetloplavi svežanj",
  "item.minecraft.light_blue_dye": "Svjetloplava boja",
  "item.minecraft.light_blue_harness": "Svjetloplava orma",
  "item.minecraft.light_gray_bundle": "Svjetlosivi svežanj",
  "item.minecraft.light_gray_dye": "Svjetlosiva boja",
  "item.minecraft.light_gray_harness": "Svjetlosiva orma",
  "item.minecraft.lime_bundle": "Svjetlozeleni svežanj",
  "item.minecraft.lime_dye": "Svjetlozelena boja",
  "item.minecraft.lime_harness": "Svjetlozelena orma",
  "item.minecraft.lingering_potion": "Dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.awkward": "Čudan dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.empty": "Dugotrajni neizradiv napitak",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dugotrajni napitak otpornosti na vatru",
  "item.minecraft.lingering_potion.effect.harming": "Dugotrajni napitak štete",
  "item.minecraft.lingering_potion.effect.healing": "Dugotrajni napitak liječenja",
  "item.minecraft.lingering_potion.effect.infested": "Dugotrajni napitak najezde",
  "item.minecraft.lingering_potion.effect.invisibility": "Dugotrajni napitak nevidljivosti",
  "item.minecraft.lingering_potion.effect.leaping": "Dugotrajni napitak skakanja",
  "item.minecraft.lingering_potion.effect.levitation": "Dugotrajni napitak lebdenja",
  "item.minecraft.lingering_potion.effect.luck": "Dugotrajni napitak sreće",
  "item.minecraft.lingering_potion.effect.mundane": "Jednostavni dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.night_vision": "Dugotrajni napitak noćnog vida",
  "item.minecraft.lingering_potion.effect.oozing": "Dugotrajni napitak sluzavosti",
  "item.minecraft.lingering_potion.effect.poison": "Dugotrajni otrovni napitak",
  "item.minecraft.lingering_potion.effect.regeneration": "Dugotrajni napitak regeneracije",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dugotrajni napitak sporog padanja",
  "item.minecraft.lingering_potion.effect.slowness": "Dugotrajni napitak sporosti",
  "item.minecraft.lingering_potion.effect.strength": "Dugotrajni napitak snage",
  "item.minecraft.lingering_potion.effect.swiftness": "Dugotrajni napitak brzine",
  "item.minecraft.lingering_potion.effect.thick": "Gusti dugotrajni napitak",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dugotrajni napitak Gospodara kornjača",
  "item.minecraft.lingering_potion.effect.water": "Dugotrajna boca vode",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dugotrajni napitak podvodnog disanja",
  "item.minecraft.lingering_potion.effect.weakness": "Dugotrajni napitak slabosti",
  "item.minecraft.lingering_potion.effect.weaving": "Dugotrajni napitak tkanja",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dugotrajni napitak vjetrovitosti",
  "item.minecraft.llama_spawn_egg": "Jaje za stvaranje ljame",
  "item.minecraft.lodestone_compass": "Kompas za magnetit",
  "item.minecraft.mace": "Buzdovan",
  "item.minecraft.magenta_bundle": "Roza svežanj",
  "item.minecraft.magenta_dye": "Roza boja",
  "item.minecraft.magenta_harness": "Roza orma",
  "item.minecraft.magma_cream": "Magmasta kuglica",
  "item.minecraft.magma_cube_spawn_egg": "Jaje za stvaranje magma kocke",
  "item.minecraft.mangrove_boat": "Čamac od mangrova",
  "item.minecraft.mangrove_chest_boat": "Čamac od mangrova sa škrinjom",
  "item.minecraft.map": "Prazna karta",
  "item.minecraft.melon_seeds": "Sjemenke lubenice",
  "item.minecraft.melon_slice": "Kriška lubenice",
  "item.minecraft.milk_bucket": "Kanta s mlijekom",
  "item.minecraft.minecart": "Vagon",
  "item.minecraft.miner_pottery_shard": "Krhotina lončanice rudar",
  "item.minecraft.miner_pottery_sherd": "Krhotina lončanice rudar",
  "item.minecraft.mojang_banner_pattern": "Uzorak zastave",
  "item.minecraft.mojang_banner_pattern.desc": "Stvar",
  "item.minecraft.mojang_banner_pattern.new": "Uzorak zastave stvari",
  "item.minecraft.mooshroom_spawn_egg": "Jaje za stvaranje mooshrooma",
  "item.minecraft.mourner_pottery_shard": "Krhotina lončanice žal",
  "item.minecraft.mourner_pottery_sherd": "Krhotina lončanice žal",
  "item.minecraft.mule_spawn_egg": "Jaje za stvaranje mazge",
  "item.minecraft.mushroom_stew": "Gulaš od gljiva",
  "item.minecraft.music_disc_11": "Glazbeni disk",
  "item.minecraft.music_disc_11.desc": "C418 – 11",
  "item.minecraft.music_disc_13": "Glazbeni disk",
  "item.minecraft.music_disc_13.desc": "C418 – 13",
  "item.minecraft.music_disc_5": "Glazbeni disk",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Glazbeni disk",
  "item.minecraft.music_disc_blocks.desc": "C418 – blocks",
  "item.minecraft.music_disc_cat": "Glazbeni disk",
  "item.minecraft.music_disc_cat.desc": "C418 – cat",
  "item.minecraft.music_disc_chirp": "Glazbeni disk",
  "item.minecraft.music_disc_chirp.desc": "C418 – chirp",
  "item.minecraft.music_disc_creator": "Glazbeni disk",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Glazbeni disk",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (glazbena kutija)",
  "item.minecraft.music_disc_far": "Glazbeni disk",
  "item.minecraft.music_disc_far.desc": "C418 – far",
  "item.minecraft.music_disc_lava_chicken": "Glazbeni disk",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Glazbeni disk",
  "item.minecraft.music_disc_mall.desc": "C418 – mall",
  "item.minecraft.music_disc_mellohi": "Glazbeni disk",
  "item.minecraft.music_disc_mellohi.desc": "C418 – mellohi",
  "item.minecraft.music_disc_otherside": "Glazbeni disk",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Glazbeni disk",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine – Pigstep",
  "item.minecraft.music_disc_precipice": "Glazbeni disk",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Glazbeni disk",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Glazbeni disk",
  "item.minecraft.music_disc_stal.desc": "C418 – stal",
  "item.minecraft.music_disc_strad": "Glazbeni disk",
  "item.minecraft.music_disc_strad.desc": "C418 – strad",
  "item.minecraft.music_disc_tears": "Glazbeni disk",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Glazbeni disk",
  "item.minecraft.music_disc_wait.desc": "C418 – wait",
  "item.minecraft.music_disc_ward": "Glazbeni disk",
  "item.minecraft.music_disc_ward.desc": "C418 – ward",
  "item.minecraft.mutton": "Sirova janjetina",
  "item.minecraft.name_tag": "Oznaka s imenom",
  "item.minecraft.nautilus_shell": "Ljuska nautilusa",
  "item.minecraft.nautilus_spawn_egg": "Jaje za stvaranje nautilusa",
  "item.minecraft.nether_brick": "Nether cigla",
  "item.minecraft.nether_star": "Nether zvijezda",
  "item.minecraft.nether_wart": "Nether lišaj",
  "item.minecraft.netherite_axe": "Netheritna sjekira",
  "item.minecraft.netherite_boots": "Netheritne čizme",
  "item.minecraft.netherite_chestplate": "Netheritni prsni oklop",
  "item.minecraft.netherite_helmet": "Netheritni šljem",
  "item.minecraft.netherite_hoe": "Netheritna motika",
  "item.minecraft.netherite_horse_armor": "Netheritni konjski oklop",
  "item.minecraft.netherite_ingot": "Netheritna poluga",
  "item.minecraft.netherite_leggings": "Netheritne gamaše",
  "item.minecraft.netherite_nautilus_armor": "Netheritni oklop nautilusa",
  "item.minecraft.netherite_pickaxe": "Netheritni kramp",
  "item.minecraft.netherite_scrap": "Komadić netherita",
  "item.minecraft.netherite_shovel": "Netheritna lopata",
  "item.minecraft.netherite_spear": "Netheritno koplje",
  "item.minecraft.netherite_sword": "Netheritni mač",
  "item.minecraft.netherite_upgrade_smithing_template": "Predložak za kovanje",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Nadogradnja na netherit",
  "item.minecraft.oak_boat": "Čamac od hrasta",
  "item.minecraft.oak_chest_boat": "Čamac od hrasta sa škrinjom",
  "item.minecraft.ocelot_spawn_egg": "Jaje za stvaranje ocelota",
  "item.minecraft.ominous_bottle": "Zloslutna bočica",
  "item.minecraft.ominous_trial_key": "Zlosutni izazovni ključ",
  "item.minecraft.orange_bundle": "Narančasti svežanj",
  "item.minecraft.orange_dye": "Narančasta boja",
  "item.minecraft.orange_harness": "Narančasta orma",
  "item.minecraft.painting": "Slika",
  "item.minecraft.pale_oak_boat": "Čamac od blijedog hrasta",
  "item.minecraft.pale_oak_chest_boat": "Čamac od blijedog hrasta sa škrinjom",
  "item.minecraft.panda_spawn_egg": "Jaje za stvaranje pande",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Jaje za stvaranje pustinjskog kostura",
  "item.minecraft.parrot_spawn_egg": "Jaje za stvaranje papige",
  "item.minecraft.phantom_membrane": "Fantomska membrana",
  "item.minecraft.phantom_spawn_egg": "Jaje za stvaranje fantoma",
  "item.minecraft.pig_spawn_egg": "Jaje za stvaranje svinje",
  "item.minecraft.piglin_banner_pattern": "Uzorak zastave",
  "item.minecraft.piglin_banner_pattern.desc": "Lik njuške",
  "item.minecraft.piglin_banner_pattern.new": "Uzorak zastave njuška",
  "item.minecraft.piglin_brute_spawn_egg": "Jaje za stvaranje surovog piglina",
  "item.minecraft.piglin_spawn_egg": "Jaje za stvaranje piglina",
  "item.minecraft.pillager_spawn_egg": "Jaje za stvaranje razbojnika",
  "item.minecraft.pink_bundle": "Ružičasti svežanj",
  "item.minecraft.pink_dye": "Ružičasta boja",
  "item.minecraft.pink_harness": "Ružičasta orma",
  "item.minecraft.pitcher_plant": "Vrčonoša",
  "item.minecraft.pitcher_pod": "Čahura vrčonoše",
  "item.minecraft.plenty_pottery_shard": "Krhotina lončanice obilje",
  "item.minecraft.plenty_pottery_sherd": "Krhotina lončanice obilje",
  "item.minecraft.poisonous_potato": "Otrovni krumpir",
  "item.minecraft.polar_bear_spawn_egg": "Jaje za stvaranje polarnog medvjeda",
  "item.minecraft.popped_chorus_fruit": "Ispucano voće chorusa",
  "item.minecraft.porkchop": "Sirova svinjetina",
  "item.minecraft.potato": "Krumpir",
  "item.minecraft.potion": "Napitak",
  "item.minecraft.potion.effect.awkward": "Čudni napitak",
  "item.minecraft.potion.effect.empty": "Neizradiv napitak",
  "item.minecraft.potion.effect.fire_resistance": "Napitak zaštite od vatre",
  "item.minecraft.potion.effect.harming": "Napitak štete",
  "item.minecraft.potion.effect.healing": "Napitak liječenja",
  "item.minecraft.potion.effect.infested": "Napitak najezde",
  "item.minecraft.potion.effect.invisibility": "Napitak nevidljivosti",
  "item.minecraft.potion.effect.leaping": "Napitak skakanja",
  "item.minecraft.potion.effect.levitation": "Napitak lebdenja",
  "item.minecraft.potion.effect.luck": "Napitak sreće",
  "item.minecraft.potion.effect.mundane": "Jednostavni napitak",
  "item.minecraft.potion.effect.night_vision": "Napitak noćnog vida",
  "item.minecraft.potion.effect.oozing": "Napitak sluzavosti",
  "item.minecraft.potion.effect.poison": "Otrovni napitak",
  "item.minecraft.potion.effect.regeneration": "Napitak regeneracije",
  "item.minecraft.potion.effect.slow_falling": "Napitak polaganog padanja",
  "item.minecraft.potion.effect.slowness": "Napitak sporosti",
  "item.minecraft.potion.effect.strength": "Napitak snage",
  "item.minecraft.potion.effect.swiftness": "Napitak brzine",
  "item.minecraft.potion.effect.thick": "Gusti napitak",
  "item.minecraft.potion.effect.turtle_master": "Napitak Gospodara kornjača",
  "item.minecraft.potion.effect.water": "Bočica vode",
  "item.minecraft.potion.effect.water_breathing": "Napitak podvodnog disanja",
  "item.minecraft.potion.effect.weakness": "Napitak slabosti",
  "item.minecraft.potion.effect.weaving": "Napitak tkanja",
  "item.minecraft.potion.effect.wind_charged": "Napitak vjetrovitosti",
  "item.minecraft.pottery_shard_archer": "Krhotina lončanice strijelac",
  "item.minecraft.pottery_shard_arms_up": "Krhotina lončanice zabava",
  "item.minecraft.pottery_shard_prize": "Krhotina lončanice nagrada",
  "item.minecraft.pottery_shard_skull": "Krhotina lončanice lubanja",
  "item.minecraft.powder_snow_bucket": "Kanta sa snježnim prahom",
  "item.minecraft.prismarine_crystals": "Kristali prizmarina",
  "item.minecraft.prismarine_shard": "Krhotina prizmarina",
  "item.minecraft.prize_pottery_shard": "Krhotina lončanice nagrada",
  "item.minecraft.prize_pottery_sherd": "Krhotina lončanice nagrada",
  "item.minecraft.pufferfish": "Napuhača",
  "item.minecraft.pufferfish_bucket": "Kanta s napuhačom",
  "item.minecraft.pufferfish_spawn_egg": "Jaje za stvaranje napuhače",
  "item.minecraft.pumpkin_pie": "Pita od bundeve",
  "item.minecraft.pumpkin_seeds": "Sjemenke bundeve",
  "item.minecraft.purple_bundle": "Ljubičasti svežanj",
  "item.minecraft.purple_dye": "Ljubičasta boja",
  "item.minecraft.purple_harness": "Ljubičasta orma",
  "item.minecraft.quartz": "Nether kvarc",
  "item.minecraft.rabbit": "Sirova zečetina",
  "item.minecraft.rabbit_foot": "Zečja šapa",
  "item.minecraft.rabbit_hide": "Zečja koža",
  "item.minecraft.rabbit_spawn_egg": "Jaje za stvaranje zeca",
  "item.minecraft.rabbit_stew": "Gulaš od zeca",
  "item.minecraft.raiser_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Oklopni ukras odgajatelj",
  "item.minecraft.ravager_spawn_egg": "Jaje za stvaranje razarača",
  "item.minecraft.raw_copper": "Sirovi bakar",
  "item.minecraft.raw_gold": "Sirovo zlato",
  "item.minecraft.raw_iron": "Sirovo željezo",
  "item.minecraft.recovery_compass": "Povratni kompas",
  "item.minecraft.red_bundle": "Crveni svežanj",
  "item.minecraft.red_dye": "Crvena boja",
  "item.minecraft.red_harness": "Crvena orma",
  "item.minecraft.redstone": "Redstone prašina",
  "item.minecraft.resin_brick": "Smolina cigla",
  "item.minecraft.resin_clump": "Gruda smole",
  "item.minecraft.rib_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rebrasti oklopni set",
  "item.minecraft.rotten_flesh": "Trulo meso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Sirovi losos",
  "item.minecraft.salmon_bucket": "Kanta s lososom",
  "item.minecraft.salmon_spawn_egg": "Jaje za stvaranje lososa",
  "item.minecraft.scrape_pottery_sherd": "Krhotina lončanice strugač",
  "item.minecraft.scute": "Ljuska",
  "item.minecraft.sentry_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Oklopni ukras stražar",
  "item.minecraft.shaper_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Oklopni ukras oblikovatelj",
  "item.minecraft.sheaf_pottery_shard": "Krhotina lončanice snop",
  "item.minecraft.sheaf_pottery_sherd": "Krhotina lončanice snop",
  "item.minecraft.shears": "Škare",
  "item.minecraft.sheep_spawn_egg": "Jaje za stvaranje ovce",
  "item.minecraft.shelter_pottery_shard": "Krhotina lončanice zaklon",
  "item.minecraft.shelter_pottery_sherd": "Krhotina lončanice zaklon",
  "item.minecraft.shield": "Štit",
  "item.minecraft.shield.black": "Crni štit",
  "item.minecraft.shield.blue": "Plavi štit",
  "item.minecraft.shield.brown": "Smeđi štit",
  "item.minecraft.shield.cyan": "Tirkizni štit",
  "item.minecraft.shield.gray": "Sivi štit",
  "item.minecraft.shield.green": "Zeleni štit",
  "item.minecraft.shield.light_blue": "Svjetloplavi štit",
  "item.minecraft.shield.light_gray": "Svjetlosivi štit",
  "item.minecraft.shield.lime": "Svjetlozeleni štit",
  "item.minecraft.shield.magenta": "Roza štit",
  "item.minecraft.shield.orange": "Narančasti štit",
  "item.minecraft.shield.pink": "Ružičasti štit",
  "item.minecraft.shield.purple": "Ljubičasti štit",
  "item.minecraft.shield.red": "Crveni štit",
  "item.minecraft.shield.white": "Bijeli štit",
  "item.minecraft.shield.yellow": "Žuti štit",
  "item.minecraft.shulker_shell": "Shulkerova ljuska",
  "item.minecraft.shulker_spawn_egg": "Jaje za stvaranje shulkera",
  "item.minecraft.sign": "Znak",
  "item.minecraft.silence_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Oklopni set Tišina",
  "item.minecraft.silverfish_spawn_egg": "Jaje za stvaranje srebrne ribice",
  "item.minecraft.skeleton_horse_spawn_egg": "Jaje za stvaranje kosturskog konja",
  "item.minecraft.skeleton_spawn_egg": "Jaje za stvaranje kostura",
  "item.minecraft.skull_banner_pattern": "Uzorak zastave",
  "item.minecraft.skull_banner_pattern.desc": "Lik lubanje",
  "item.minecraft.skull_banner_pattern.new": "Uzorak barjaka Lubanja",
  "item.minecraft.skull_pottery_shard": "Krhotina lončanice lubanja",
  "item.minecraft.skull_pottery_sherd": "Krhotina lončanice lubanja",
  "item.minecraft.slime_ball": "Ljigava kuglica",
  "item.minecraft.slime_spawn_egg": "Jaje za stvaranje ljigavca",
  "item.minecraft.smithing_template": "Predložak za kovanje",
  "item.minecraft.smithing_template.applies_to": "Odnosi se na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodaj polugu ili kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Oklop",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodaj dio oklopa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Poluge i kristali",
  "item.minecraft.smithing_template.ingredients": "Sastojci:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj netheritnu polugu",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dijamantna oprema",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj dijamantni oklop, oružje ili alat",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritna poluga",
  "item.minecraft.smithing_template.upgrade": "Nadogradnje: ",
  "item.minecraft.sniffer_spawn_egg": "Jaje za stvaranje njuška",
  "item.minecraft.snort_pottery_shard": "Krhotina lončanice miris",
  "item.minecraft.snort_pottery_sherd": "Krhotina lončanice miris",
  "item.minecraft.snout_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Oklopni ukras njuška",
  "item.minecraft.snow_golem_spawn_egg": "Jaje za stvaranje snježnog čuvara",
  "item.minecraft.snowball": "Snježna gruda",
  "item.minecraft.spectral_arrow": "Spektralna strijela",
  "item.minecraft.spider_eye": "Paukovo oko",
  "item.minecraft.spider_spawn_egg": "Jaje za stvaranje pauka",
  "item.minecraft.spire_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Oklopni ukras špic",
  "item.minecraft.splash_potion": "Prskajući napitak",
  "item.minecraft.splash_potion.effect.awkward": "Čudni prskajući napitak",
  "item.minecraft.splash_potion.effect.empty": "Neizradiv prskajući napitak",
  "item.minecraft.splash_potion.effect.fire_resistance": "Prskajući napitak zaštite od vatre",
  "item.minecraft.splash_potion.effect.harming": "Prskajući napitak štete",
  "item.minecraft.splash_potion.effect.healing": "Prskajući napitak liječenja",
  "item.minecraft.splash_potion.effect.infested": "Prskajući napitak najezde",
  "item.minecraft.splash_potion.effect.invisibility": "Prskajući napitak nevidljivosti",
  "item.minecraft.splash_potion.effect.leaping": "Prskajući napitak skakanja",
  "item.minecraft.splash_potion.effect.levitation": "Prskajući napitak lebdenja",
  "item.minecraft.splash_potion.effect.luck": "Prskajući napitak sreće",
  "item.minecraft.splash_potion.effect.mundane": "Jednostavni prskajući napitak",
  "item.minecraft.splash_potion.effect.night_vision": "Prskajući napitak noćnog vida",
  "item.minecraft.splash_potion.effect.oozing": "Prskajući napitak sluzavosti",
  "item.minecraft.splash_potion.effect.poison": "Prskajući otrovni napitak",
  "item.minecraft.splash_potion.effect.regeneration": "Prskajući napitak regeneracije",
  "item.minecraft.splash_potion.effect.slow_falling": "Prskajući napitak polaganog padanja",
  "item.minecraft.splash_potion.effect.slowness": "Prskajući napitak sporosti",
  "item.minecraft.splash_potion.effect.strength": "Prskajući napitak snage",
  "item.minecraft.splash_potion.effect.swiftness": "Prskajući napitak brzine",
  "item.minecraft.splash_potion.effect.thick": "Gusti prskajući napitak",
  "item.minecraft.splash_potion.effect.turtle_master": "Prskajući napitak Gospodara kornjača",
  "item.minecraft.splash_potion.effect.water": "Prskajuća boca vode",
  "item.minecraft.splash_potion.effect.water_breathing": "Prskajući napitak podvodnog disanja",
  "item.minecraft.splash_potion.effect.weakness": "Prskajući napitak slabosti",
  "item.minecraft.splash_potion.effect.weaving": "Prskajući napitak tkanja",
  "item.minecraft.splash_potion.effect.wind_charged": "Prskajući napitak vjetrovitosti",
  "item.minecraft.spruce_boat": "Čamac od smreke",
  "item.minecraft.spruce_chest_boat": "Čamac od smreke sa škrinjom",
  "item.minecraft.spyglass": "Dalekozor",
  "item.minecraft.squid_spawn_egg": "Jaje za stvaranje lignje",
  "item.minecraft.stick": "Štap",
  "item.minecraft.stone_axe": "Kamena sjekira",
  "item.minecraft.stone_hoe": "Kamena motika",
  "item.minecraft.stone_pickaxe": "Kameni kramp",
  "item.minecraft.stone_shovel": "Kamena lopata",
  "item.minecraft.stone_spear": "Kameno koplje",
  "item.minecraft.stone_sword": "Kameni mač",
  "item.minecraft.stray_spawn_egg": "Jaje za stvaranje lutalice",
  "item.minecraft.strider_spawn_egg": "Jaje za stvaranje paklenog šetača",
  "item.minecraft.string": "Nit",
  "item.minecraft.sugar": "Šećer",
  "item.minecraft.suspicious_stew": "Sumnjivi gulaš",
  "item.minecraft.sweet_berries": "Slatke bobice",
  "item.minecraft.tadpole_bucket": "Kanta s punoglavcem",
  "item.minecraft.tadpole_spawn_egg": "Jaje za stvaranje punoglavca",
  "item.minecraft.tide_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Oklopni ukras plima",
  "item.minecraft.tipped_arrow": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.awkward": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.empty": "Neizradiva umočena strijela",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strijela zaštite od vatre",
  "item.minecraft.tipped_arrow.effect.harming": "Strijela štete",
  "item.minecraft.tipped_arrow.effect.healing": "Strijela liječenja",
  "item.minecraft.tipped_arrow.effect.infested": "Strijela najezde",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strijela nevidljivosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Strijela skakanja",
  "item.minecraft.tipped_arrow.effect.levitation": "Strijela lebdenja",
  "item.minecraft.tipped_arrow.effect.luck": "Strijela sreće",
  "item.minecraft.tipped_arrow.effect.mundane": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strijela noćnog vida",
  "item.minecraft.tipped_arrow.effect.oozing": "Strijela izlučivanja",
  "item.minecraft.tipped_arrow.effect.poison": "Otrovna strijela",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strijela regeneracije",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strijela polaganog padanja",
  "item.minecraft.tipped_arrow.effect.slowness": "Strijela usporavanja",
  "item.minecraft.tipped_arrow.effect.strength": "Strijela snage",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strijela brzine",
  "item.minecraft.tipped_arrow.effect.thick": "Umočena strijela",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strijela Gospodara kornjača",
  "item.minecraft.tipped_arrow.effect.water": "Strijela prskanja",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strijela podvodnog disanja",
  "item.minecraft.tipped_arrow.effect.weakness": "Strijela slabosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Strijela tkanja",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strijela vjetrovitosti",
  "item.minecraft.tnt_minecart": "Vagon s TNT-om",
  "item.minecraft.torchflower_seeds": "Sjemenke bakljocvijeta",
  "item.minecraft.totem_of_undying": "Totem besmrtnosti",
  "item.minecraft.trader_llama_spawn_egg": "Jaje za stvaranje trgovčeve ljame",
  "item.minecraft.trial_key": "Izazovni ključ",
  "item.minecraft.trident": "Trozubac",
  "item.minecraft.tropical_fish": "Tropska riba",
  "item.minecraft.tropical_fish_bucket": "Kanta s tropskom ribom",
  "item.minecraft.tropical_fish_spawn_egg": "Jaje za stvaranje tropske ribe",
  "item.minecraft.turtle_helmet": "Kornjačin oklop",
  "item.minecraft.turtle_scute": "Ljuska kornjače",
  "item.minecraft.turtle_spawn_egg": "Jaje za stvaranje kornjače",
  "item.minecraft.vex_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Oklopni ukras dosađivač",
  "item.minecraft.vex_spawn_egg": "Jaje za stvaranje dosađivača",
  "item.minecraft.villager_spawn_egg": "Jaje za stvaranje seljanina",
  "item.minecraft.vindicator_spawn_egg": "Jaje za stvaranje osvetnika",
  "item.minecraft.wandering_trader_spawn_egg": "Jaje za stvaranje lutajućeg trgovca",
  "item.minecraft.ward_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Oklopni ukras čuvar",
  "item.minecraft.warden_spawn_egg": "Jaje za stvaranje stražara",
  "item.minecraft.warped_fungus_on_a_stick": "Luda gljiva na štapu",
  "item.minecraft.water_bucket": "Kanta s vodom",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Oklopni ukras putokaz",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Sjemenke pšenice",
  "item.minecraft.white_bundle": "Bijeli svežanj",
  "item.minecraft.white_dye": "Bijela boja",
  "item.minecraft.white_harness": "Bijela orma",
  "item.minecraft.wild_armor_trim_smithing_template": "Predložak za kovanje",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Set oklopa Divlji",
  "item.minecraft.wind_charge": "Vjetrovita kugla",
  "item.minecraft.witch_spawn_egg": "Jaje za stvaranje vještice",
  "item.minecraft.wither_skeleton_spawn_egg": "Jaje za stvaranje Wither kostura",
  "item.minecraft.wither_spawn_egg": "Jaje za stvaranje Withera",
  "item.minecraft.wolf_armor": "Vučji oklop",
  "item.minecraft.wolf_spawn_egg": "Jaje za stvaranje vuka",
  "item.minecraft.wooden_axe": "Drvena sjekira",
  "item.minecraft.wooden_hoe": "Drvena motika",
  "item.minecraft.wooden_pickaxe": "Drveni kramp",
  "item.minecraft.wooden_shovel": "Drvena lopata",
  "item.minecraft.wooden_spear": "Drveno koplje",
  "item.minecraft.wooden_sword": "Drveni mač",
  "item.minecraft.writable_book": "Knjiga i pero",
  "item.minecraft.written_book": "Napisana knjiga",
  "item.minecraft.yellow_bundle": "Žuti svežanj",
  "item.minecraft.yellow_dye": "Žuta boja",
  "item.minecraft.yellow_harness": "Žuta orma",
  "item.minecraft.zoglin_spawn_egg": "Jaje za stvaranje zoglina",
  "item.minecraft.zombie_horse_spawn_egg": "Jaje za stvaranje zombi konja",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jaje za stvaranje zombi nautilusa",
  "item.minecraft.zombie_spawn_egg": "Jaje za stvaranje zombija",
  "item.minecraft.zombie_villager_spawn_egg": "Jaje za stvaranje zombi seljanina",
  "item.minecraft.zombified_piglin_spawn_egg": "Jaje za stvaranje zombificiranog piglina"
}
export const hr_hr = items; 
